export default {
  "fields": {
    "opdrachtgever_aanspreking": {
      "title": "Aanspreking",
      "options": [{
        "identifier": "de_heer",
        "title": "De heer"
      }, {
        "identifier": "mevrouw",
        "title": "Mevrouw"
      }, {
        "identifier": "de_heer_en_mevrouw",
        "title": "De heer en mevrouw"
      }, {
        "identifier": "de_familie",
        "title": "De familie"
      }, {
        "identifier": "bedrijf",
        "title": "Bedrijf"
      }, {
        "identifier": "geen",
        "title": "Geen"
      }],
      "type": "dropdown_field",
      "identifier": "opdrachtgever_aanspreking"
    },
    "opdrachtgever_achternaam": {
      "title": "Achternaam",
      "type": "text_field",
      "identifier": "opdrachtgever_achternaam"
    },
    "opdrachtgever_voornaam": {
      "title": "Voornaam",
      "type": "text_field",
      "identifier": "opdrachtgever_voornaam"
    },
    "opdrachtgever_telefoon": {
      "title": "Telefoon / GSM",
      "type": "text_field",
      "identifier": "opdrachtgever_telefoon"
    },
    "opdrachtgever_email": {
      "title": "E-mail",
      "type": "text_field",
      "identifier": "opdrachtgever_email"
    },
    "opdrachtgever_straatnaam": {
      "title": "Straatnaam",
      "type": "text_field",
      "identifier": "opdrachtgever_straatnaam"
    },
    "opdrachtgever_huisnummer": {
      "title": "Huisnummer",
      "type": "text_field",
      "identifier": "opdrachtgever_huisnummer"
    },
    "opdrachtgever_bus": {
      "title": "Bus",
      "type": "text_field",
      "identifier": "opdrachtgever_bus"
    },
    "opdrachtgever_postcode": {
      "title": "Postcode",
      "type": "text_field",
      "identifier": "opdrachtgever_postcode"
    },
    "opdrachtgever_gemeente": {
      "title": "Gemeente",
      "type": "text_field",
      "identifier": "opdrachtgever_gemeente"
    },
    "adresgegevens_gelijk_aan_te_schatten_eigendom": {
      "title": "Adresgegevens komen overeen met te schatten eigendom",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "adresgegevens_gelijk_aan_te_schatten_eigendom"
    },
    "te_schatten_straatnaam": {
      "title": "Straatnaam",
      "type": "text_field",
      "identifier": "te_schatten_straatnaam"
    },
    "te_schatten_huisnummer": {
      "title": "Huisnummer",
      "type": "text_field",
      "identifier": "te_schatten_huisnummer"
    },
    "te_schatten_bus": {
      "title": "Bus",
      "type": "text_field",
      "identifier": "te_schatten_bus"
    },
    "te_schatten_postcode": {
      "title": "Postcode",
      "type": "text_field",
      "identifier": "te_schatten_postcode"
    },
    "te_schatten_gemeente": {
      "title": "Gemeente",
      "type": "text_field",
      "identifier": "te_schatten_gemeente"
    },
    "ligging_en_omgeving": {
      "title": "Ligging en omgeving",
      "options": [{
        "identifier": "in_de_dorpskern",
        "title": "In de dorpskern"
      }, {
        "identifier": "nabij_de_dorpskern",
        "title": "Nabij de dorpskern"
      }, {
        "identifier": "in_het_stadscentrum",
        "title": "In het stadscentrum"
      }, {
        "identifier": "nabij_het_stadscentrum",
        "title": "Nabij het stadscentrum"
      }, {
        "identifier": "nabij_een_autosnelweg",
        "title": "Nabij een autosnelweg"
      }, {
        "identifier": "landelijke_omgeving",
        "title": "Landelijke omgeving"
      }, {
        "identifier": "nabij_industriezone",
        "title": "Nabij industriezone"
      }, {
        "identifier": "in_een_industriezone",
        "title": "In een industriezone"
      }, {
        "identifier": "in_een_villawijk",
        "title": "In een villawijk"
      }, {
        "identifier": "nabij_school_scholen",
        "title": "Nabij school / scholen"
      }, {
        "identifier": "nabij_openbaar_vervoer",
        "title": "Nabij openbaar vervoer"
      }, {
        "identifier": "nabij_winkelcentra_en_horeca",
        "title": "Nabij winkelcentra en horeca"
      }, {
        "identifier": "vrij_zicht_achteraan",
        "title": "Vrij zicht achteraan"
      }, {
        "identifier": "rustige_ligging",
        "title": "Rustige ligging"
      }, {
        "identifier": "drukkere_ligging",
        "title": "Drukke(re) ligging"
      }, {
        "identifier": "residentiele_ligging",
        "title": "Residentiële ligging"
      }, {
        "identifier": "kmo_zone",
        "title": "KMO zone"
      }, {
        "identifier": "handelscentrum",
        "title": "Handelscentrum"
      }, {
        "identifier": "recreatiezone",
        "title": "Recreatiezone"
      }, {
        "identifier": "nabij_de_nederlandse_grens",
        "title": "Nabij de Nederlandse grens"
      }, {
        "identifier": "nabij_de_duitse_grens",
        "title": "Nabij de Duitse grens"
      }, {
        "identifier": "nabij_de_franse_grens",
        "title": "Nabij de Franse grens"
      }, {
        "identifier": "zeezicht",
        "title": "Zeezicht"
      }, {
        "identifier": "zeedijk",
        "title": "Zeedijk"
      }, {
        "identifier": "nabij_strand",
        "title": "Nabij strand"
      }, {
        "identifier": "nabij_golf",
        "title": "Nabij golf"
      }],
      "type": "multi_checkbox_field",
      "identifier": "ligging_en_omgeving"
    },
    "stedenbouwkundige_vergunning_afgeleverd": {
      "title": "Stedenbouwkundige vergunning afgeleverd",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }, {
        "identifier": "niet_gekend",
        "title": "Niet gekend"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "stedenbouwkundige_vergunning_afgeleverd"
    },
    "dagvaarding_uitgebracht": {
      "title": "Dagvaarding uitgebracht",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }, {
        "identifier": "niet_gekend",
        "title": "Niet gekend"
      }],
      "default": "nee",
      "type": "segmented_control_field",
      "identifier": "dagvaarding_uitgebracht"
    },
    "voorkooprecht": {
      "title": "Voorkooprecht",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }, {
        "identifier": "niet_gekend",
        "title": "Niet gekend"
      }],
      "default": "niet_gekend",
      "type": "segmented_control_field",
      "identifier": "voorkooprecht"
    },
    "verkavelingsvergunning": {
      "title": "Verkavelingsvergunning",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }, {
        "identifier": "niet_gekend",
        "title": "Niet gekend"
      }],
      "default": "niet_gekend",
      "type": "segmented_control_field",
      "identifier": "verkavelingsvergunning"
    },
    "watertoets": {
      "title": "Watertoets",
      "options": [{
        "identifier": "niet_gekend",
        "title": "Niet gekend"
      }, {
        "identifier": "risicozone_voor_overstromingen",
        "title": "Risicozone voor overstromingen"
      }, {
        "identifier": "effectief_overstromingsgevoelig_gebied",
        "title": "Effectief overstromingsgevoelig gebied"
      }, {
        "identifier": "mogelijk_overstromingsgevoelig_gebied",
        "title": "Mogelijk overstromingsgevoelig gebied"
      }, {
        "identifier": "niet_overstromingsgevoelig_gebied",
        "title": "Niet overstromingsgevoelig gebied"
      }],
      "default": "niet_overstromingsgevoelig_gebied",
      "type": "dropdown_field",
      "identifier": "watertoets"
    },
    "bestemmingsgebied": {
      "title": "Bestemmingsgebied",
      "options": [{
        "identifier": "niet_gekend",
        "title": "Niet gekend"
      }, {
        "identifier": "woongebied",
        "title": "Woongebied"
      }],
      "default": "woongebied",
      "type": "dropdown_field",
      "identifier": "bestemmingsgebied"
    },
    "as_built_attest_verkregen": {
      "title": "As-built attest verkregen",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }, {
        "identifier": "niet_gekend",
        "title": "Niet gekend"
      }],
      "default": "niet_gekend",
      "type": "segmented_control_field",
      "identifier": "as_built_attest_verkregen"
    },
    "maakt_deel_uit_van_een_voorkeursbesluit_projectbesluit": {
      "title": "Maakt deel uit van een voorkeursbesluit/projectbesluit",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }, {
        "identifier": "niet_gekend",
        "title": "Niet gekend"
      }],
      "default": "niet_gekend",
      "type": "segmented_control_field",
      "identifier": "maakt_deel_uit_van_een_voorkeursbesluit_projectbesluit"
    },
    "beschermd_eigendom": {
      "title": "Beschermd eigendom",
      "options": [{
        "identifier": "geen",
        "title": "Geen"
      }, {
        "identifier": "beschermd_pand",
        "title": "Beschermd pand"
      }, {
        "identifier": "beschermd_monument",
        "title": "Beschermd monument"
      }, {
        "identifier": "beschermd_landschap",
        "title": "Beschermd landschap"
      }, {
        "identifier": "beschermd_cultuurhistorisch_landschap",
        "title": "Beschermd cultuurhistorisch landschap"
      }, {
        "identifier": "beschermd_stadsgezicht",
        "title": "Beschermd stadsgezicht"
      }, {
        "identifier": "beschermd_dorpsgezicht",
        "title": "Beschermd dorpsgezicht"
      }, {
        "identifier": "beschermde_archeologische_site",
        "title": "Beschermde archeologische site"
      }, {
        "identifier": "beschermde_archeologische_zone",
        "title": "Beschermde archeologische zone"
      }, {
        "identifier": "beschermd_archeologisch_monument",
        "title": "Beschermd archeologisch monument"
      }],
      "default": "geen",
      "type": "dropdown_field",
      "identifier": "beschermd_eigendom"
    },
    "onroerend_goed_type": {
      "title": "Onroerend goed",
      "options": [{
        "identifier": "appartement",
        "title": "Appartement"
      }, {
        "identifier": "woning",
        "title": "Woning"
      }, {
        "identifier": "grond",
        "title": "Grond"
      }, {
        "identifier": "commercieel",
        "title": "Commercieel"
      }, {
        "identifier": "industrieel",
        "title": "Industrieel"
      }, {
        "identifier": "garage",
        "title": "Garage"
      }, {
        "identifier": "kantoor",
        "title": "Kantoor"
      }],
      "default": "appartement",
      "type": "dropdown_field",
      "identifier": "onroerend_goed_type"
    },
    "onroerend_goed_subtype": {
      "title": "Type",
      "options": [{
        "identifier": "appartement",
        "title": "Appartement",
        "group": "appartement"
      }, {
        "identifier": "gelijkvloers",
        "title": "Gelijkvloers",
        "group": "appartement"
      }, {
        "identifier": "penthouse",
        "title": "Penthouse",
        "group": "appartement"
      }, {
        "identifier": "nieuwbouw_appartementen",
        "title": "Nieuwbouw appartementen",
        "group": "appartement"
      }, {
        "identifier": "service_flats",
        "title": "Service flats",
        "group": "appartement"
      }, {
        "identifier": "dakappartement",
        "title": "Dakappartement",
        "group": "appartement"
      }, {
        "identifier": "studentenkamer",
        "title": "Studentenkamer",
        "group": "appartement"
      }, {
        "identifier": "duplex",
        "title": "Duplex",
        "group": "appartement"
      }, {
        "identifier": "triplex",
        "title": "Triplex",
        "group": "appartement"
      }, {
        "identifier": "flat",
        "title": "Flat",
        "group": "appartement"
      }, {
        "identifier": "studio",
        "title": "Studio",
        "group": "appartement"
      }, {
        "identifier": "loft",
        "title": "Loft",
        "group": "appartement"
      }, {
        "identifier": "appartement_met_tuin",
        "title": "Appartement met tuin",
        "group": "appartement"
      }, {
        "identifier": "gelijkvloerse_verdieping",
        "title": "Gelijkvloerse verdieping",
        "group": "appartement"
      }, {
        "identifier": "appartement_in_charmant_huis",
        "title": "Appartement in charmant huis",
        "group": "appartement"
      }, {
        "identifier": "appartementencomplex_gemengd",
        "title": "Appartementencomplex gemengd",
        "group": "appartement"
      }, {
        "identifier": "overig",
        "title": "Overig",
        "group": "appartement"
      }, {
        "identifier": "chalet",
        "title": "Chalet",
        "group": "woning"
      }, {
        "identifier": "woning",
        "title": "Woning",
        "group": "woning"
      }, {
        "identifier": "landgebouw",
        "title": "Landgebouw",
        "group": "woning"
      }, {
        "identifier": "gebouw_voor_gemengd_gebruik",
        "title": "Gebouw voor gemengd gebruik",
        "group": "woning"
      }, {
        "identifier": "garagebox",
        "title": "Garagebox",
        "group": "woning"
      }, {
        "identifier": "bungalow",
        "title": "Bungalow",
        "group": "woning"
      }, {
        "identifier": "boerderij",
        "title": "Boerderij",
        "group": "woning"
      }, {
        "identifier": "buitengewoon_huis",
        "title": "Buitengewoon huis",
        "group": "woning"
      }, {
        "identifier": "bel_etage",
        "title": "Bel-etage",
        "group": "woning"
      }, {
        "identifier": "appartementsgebouw",
        "title": "Appartementsgebouw",
        "group": "woning"
      }, {
        "identifier": "recreatiewoning",
        "title": "Recreatiewoning",
        "group": "woning"
      }, {
        "identifier": "hoeve",
        "title": "Hoeve",
        "group": "woning"
      }, {
        "identifier": "villa",
        "title": "Villa",
        "group": "woning"
      }, {
        "identifier": "huis",
        "title": "Huis",
        "group": "woning"
      }, {
        "identifier": "herenhuis",
        "title": "Herenhuis",
        "group": "woning"
      }, {
        "identifier": "nieuwbouw_woning",
        "title": "Nieuwbouw woning",
        "group": "woning"
      }, {
        "identifier": "koppelvilla",
        "title": "Koppelvilla",
        "group": "woning"
      }, {
        "identifier": "eengezinswoning",
        "title": "Eengezinswoning",
        "group": "woning"
      }, {
        "identifier": "vakantiewoning",
        "title": "Vakantiewoning",
        "group": "woning"
      }, {
        "identifier": "charmant_huis",
        "title": "Charmant huis",
        "group": "woning"
      }, {
        "identifier": "landhuis",
        "title": "Landhuis",
        "group": "woning"
      }, {
        "identifier": "kasteel",
        "title": "Kasteel",
        "group": "woning"
      }, {
        "identifier": "overig",
        "title": "Overig",
        "group": "woning"
      }, {
        "identifier": "bouwgrond",
        "title": "Bouwgrond",
        "group": "grond"
      }, {
        "identifier": "grond",
        "title": "Grond",
        "group": "grond"
      }, {
        "identifier": "industriegrond",
        "title": "Industriegrond",
        "group": "grond"
      }, {
        "identifier": "recreatieterrein",
        "title": "Recreatieterrein",
        "group": "grond"
      }, {
        "identifier": "gesloten_bebouwing",
        "title": "Gesloten bebouwing",
        "group": "grond"
      }, {
        "identifier": "halfopen_bebouwing",
        "title": "Halfopen bebouwing",
        "group": "grond"
      }, {
        "identifier": "open_bebouwing",
        "title": "Open bebouwing",
        "group": "grond"
      }, {
        "identifier": "recreatiegrond",
        "title": "Recreatiegrond",
        "group": "grond"
      }, {
        "identifier": "projectgrond",
        "title": "Projectgrond",
        "group": "grond"
      }, {
        "identifier": "landbouwgrond",
        "title": "Landbouwground",
        "group": "grond"
      }, {
        "identifier": "bosgrond",
        "title": "Bosgrond",
        "group": "grond"
      }, {
        "identifier": "boomgaard",
        "title": "Boomgaard",
        "group": "grond"
      }, {
        "identifier": "box",
        "title": "Bos",
        "group": "grond"
      }, {
        "identifier": "landbouwgrond",
        "title": "Landbouwgrond",
        "group": "grond"
      }, {
        "identifier": "weide",
        "title": "Weide",
        "group": "grond"
      }, {
        "identifier": "recreatief_terrein",
        "title": "Recreatief terrein",
        "group": "grond"
      }, {
        "identifier": "onbebouwbare_grond",
        "title": "Onbebouwbare grond",
        "group": "grond"
      }, {
        "identifier": "velden",
        "title": "Velden",
        "group": "grond"
      }, {
        "identifier": "industrieel_terrein",
        "title": "Industrieel terrein",
        "group": "grond"
      }, {
        "identifier": "kmo_terrein",
        "title": "KMO-terrein",
        "group": "grond"
      }, {
        "identifier": "overig",
        "title": "Overig",
        "group": "grond"
      }, {
        "identifier": "hotel",
        "title": "Hotel",
        "group": "commercieel"
      }, {
        "identifier": "discotheek_dancing",
        "title": "Discotheek / dancing",
        "group": "commercieel"
      }, {
        "identifier": "delicatessenwinkel",
        "title": "Delicatessenwinkel",
        "group": "commercieel"
      }, {
        "identifier": "danscentrum",
        "title": "Danscentrum",
        "group": "commercieel"
      }, {
        "identifier": "dagexploitatie",
        "title": "Dagexploitatie",
        "group": "commercieel"
      }, {
        "identifier": "club",
        "title": "Club",
        "group": "commercieel"
      }, {
        "identifier": "coffeeshop",
        "title": "Coffeeshop",
        "group": "commercieel"
      }, {
        "identifier": "catering",
        "title": "Catering",
        "group": "commercieel"
      }, {
        "identifier": "casco_horecaruimte",
        "title": "Casco horecaruimte",
        "group": "commercieel"
      }, {
        "identifier": "discotheek_nachtcafe",
        "title": "Discotheek / nachtcafe",
        "group": "commercieel"
      }, {
        "identifier": "eetcafe",
        "title": "Eetcafe",
        "group": "commercieel"
      }, {
        "identifier": "pension",
        "title": "Pension",
        "group": "commercieel"
      }, {
        "identifier": "partycentrum",
        "title": "Partycentrum",
        "group": "commercieel"
      }, {
        "identifier": "partyboot",
        "title": "Partyboot",
        "group": "commercieel"
      }, {
        "identifier": "loungeclub",
        "title": "Loungeclub",
        "group": "commercieel"
      }, {
        "identifier": "koffieshop_koffiecafe",
        "title": "Koffieshop / koffiecafe",
        "group": "commercieel"
      }, {
        "identifier": "grand_cafe",
        "title": "Grand-cafe",
        "group": "commercieel"
      }, {
        "identifier": "gebakwinkel",
        "title": "Gebakwinkel",
        "group": "commercieel"
      }, {
        "identifier": "gamecentre",
        "title": "Gamecentre",
        "group": "commercieel"
      }, {
        "identifier": "chinees_restaurant",
        "title": "Chinees restaurant",
        "group": "commercieel"
      }, {
        "identifier": "camping",
        "title": "Camping",
        "group": "commercieel"
      }, {
        "identifier": "cafetaria_snackbar",
        "title": "Cafetaria / snackbar",
        "group": "commercieel"
      }, {
        "identifier": "kapsalon_esthetiek",
        "title": "Kapsalon / esthetiek",
        "group": "commercieel"
      }, {
        "identifier": "wagens_fietsen",
        "title": "Wagens / fietsen",
        "group": "commercieel"
      }, {
        "identifier": "modezaak_textiel",
        "title": "Modezaak / textiel",
        "group": "commercieel"
      }, {
        "identifier": "boekhandel_tabak_bloemen",
        "title": "Boekhandel / tabak / bloemen",
        "group": "commercieel"
      }, {
        "identifier": "voeding",
        "title": "Voeding",
        "group": "commercieel"
      }, {
        "identifier": "gebouw_voor_gemengd_gebruik",
        "title": "Gebouw voor gemengd gebruik",
        "group": "commercieel"
      }, {
        "identifier": "commercieel_centrum",
        "title": "Commercieel centrum",
        "group": "commercieel"
      }, {
        "identifier": "taverne",
        "title": "Taverne",
        "group": "commercieel"
      }, {
        "identifier": "baanwinkel",
        "title": "Baanwinkel",
        "group": "commercieel"
      }, {
        "identifier": "cafe_restaurant",
        "title": "Cafe / restaurant",
        "group": "commercieel"
      }, {
        "identifier": "cafe_bar",
        "title": "Cafe / bar",
        "group": "commercieel"
      }, {
        "identifier": "broodjeszaak",
        "title": "Broodjeszaak",
        "group": "commercieel"
      }, {
        "identifier": "brood_banketbakker",
        "title": "Brood / banketbakker",
        "group": "commercieel"
      }, {
        "identifier": "bed_breakfast",
        "title": "Bed & breakfast",
        "group": "commercieel"
      }, {
        "identifier": "afhaalcentrum",
        "title": "Afhaalcentrum",
        "group": "commercieel"
      }, {
        "identifier": "individuele_handelszaak",
        "title": "Individuele handelszaak",
        "group": "commercieel"
      }, {
        "identifier": "hotel_restaurant",
        "title": "Hotel / restaurant",
        "group": "commercieel"
      }, {
        "identifier": "manege",
        "title": "Manege",
        "group": "commercieel"
      }, {
        "identifier": "zalen_partycentrum",
        "title": "Zalen / partycentrum",
        "group": "commercieel"
      }, {
        "identifier": "winkelpand",
        "title": "Winkelpand",
        "group": "commercieel"
      }, {
        "identifier": "wokrestaurent",
        "title": "Wokrestaurant",
        "group": "commercieel"
      }, {
        "identifier": "restaurant_zalen",
        "title": "Restaurant / zalen",
        "group": "commercieel"
      }, {
        "identifier": "restaurant",
        "title": "Restaurant",
        "group": "commercieel"
      }, {
        "identifier": "pizzeria_bezorgservice",
        "title": "Pizzeria / bezorgservice",
        "group": "commercieel"
      }, {
        "identifier": "pizzeria",
        "title": "Pizzeria",
        "group": "commercieel"
      }, {
        "identifier": "overige_horeca",
        "title": "Overige horeca",
        "group": "commercieel"
      }, {
        "identifier": "lunchroom",
        "title": "Lunchroom",
        "group": "commercieel"
      }, {
        "identifier": "ijssalon",
        "title": "IJssalon",
        "group": "commercieel"
      }, {
        "identifier": "hostel",
        "title": "Hostel",
        "group": "commercieel"
      }, {
        "identifier": "shoarma_grillroom",
        "title": "Shoarma / grillroom",
        "group": "commercieel"
      }, {
        "identifier": "shoarma_grillroom_bezorgservice",
        "title": "Shoarma / grillroom + bezorgservice",
        "group": "commercieel"
      }, {
        "identifier": "wegrestaurant",
        "title": "Wegrestaurant",
        "group": "commercieel"
      }, {
        "identifier": "wellness",
        "title": "Wellness",
        "group": "commercieel"
      }, {
        "identifier": "viswinkel",
        "title": "Viswinkel",
        "group": "commercieel"
      }, {
        "identifier": "traiteur",
        "title": "Traiteur",
        "group": "commercieel"
      }, {
        "identifier": "tearoom",
        "title": "Tearoom",
        "group": "commercieel"
      }, {
        "identifier": "sauna",
        "title": "Sauna",
        "group": "commercieel"
      }, {
        "identifier": "strandpaviljoen",
        "title": "Strandpaviljoen",
        "group": "commercieel"
      }, {
        "identifier": "snack_viswagen",
        "title": "Snack- / viswagen",
        "group": "commercieel"
      }, {
        "identifier": "kantoor",
        "title": "Kantoor",
        "group": "commercieel"
      }, {
        "identifier": "overig",
        "title": "Overig",
        "group": "commercieel"
      }, {
        "identifier": "kantoren_magazijn",
        "title": "Kantoren & magazijn",
        "group": "industrieel"
      }, {
        "identifier": "koelplaats",
        "title": "Koelplaats",
        "group": "industrieel"
      }, {
        "identifier": "atelier",
        "title": "Atelier",
        "group": "industrieel"
      }, {
        "identifier": "productiegebouw",
        "title": "Productiegebouw",
        "group": "industrieel"
      }, {
        "identifier": "opslagplaats",
        "title": "Opslagplaats",
        "group": "industrieel"
      }, {
        "identifier": "gebouw_voor_gemengd_gebruik",
        "title": "Gebouw voor gemengd gebruik",
        "group": "industrieel"
      }, {
        "identifier": "industrieel_gebouw",
        "title": "Industrieel gebouw",
        "group": "industrieel"
      }, {
        "identifier": "kantoren",
        "title": "Kantoren",
        "group": "industrieel"
      }, {
        "identifier": "landbouwbedrijf",
        "title": "Landbouwbedrijf",
        "group": "industrieel"
      }, {
        "identifier": "tuinbouwbedrijf",
        "title": "Tuinbouwbedrijf",
        "group": "industrieel"
      }, {
        "identifier": "magazijn",
        "title": "Magazijn",
        "group": "industrieel"
      }, {
        "identifier": "boerderij",
        "title": "Boerderij",
        "group": "industrieel"
      }, {
        "identifier": "overig",
        "title": "Overig",
        "group": "industrieel"
      }, {
        "identifier": "buitenstaanplaats",
        "title": "Buitenstaanplaats",
        "group": "garage"
      }, {
        "identifier": "dubbele_garage",
        "title": "Dubbele garage",
        "group": "garage"
      }, {
        "identifier": "garage_met_berging",
        "title": "Garage met berging",
        "group": "garage"
      }, {
        "identifier": "berging",
        "title": "Berging",
        "group": "garage"
      }, {
        "identifier": "carport",
        "title": "Carport",
        "group": "garage"
      }, {
        "identifier": "gesloten_garagebox",
        "title": "Gesloten garagebox",
        "group": "garage"
      }, {
        "identifier": "open_garagebox",
        "title": "Open garagebox",
        "group": "garage"
      }, {
        "identifier": "binnenstaanplaats",
        "title": "Binnenstaanplaats",
        "group": "garage"
      }, {
        "identifier": "garage",
        "title": "Garage",
        "group": "garage"
      }, {
        "identifier": "autostaanplaats_in_garage",
        "title": "Autostaanplaats in garage",
        "group": "garage"
      }, {
        "identifier": "garagebox",
        "title": "Garagebox",
        "group": "garage"
      }, {
        "identifier": "autostaanplaats",
        "title": "Autostaanplaats",
        "group": "garage"
      }, {
        "identifier": "overig",
        "title": "Overig",
        "group": "garage"
      }, {
        "identifier": "archieven",
        "title": "Archieven",
        "group": "kantoor"
      }, {
        "identifier": "gemengd_gebruik",
        "title": "Gemengd gebruik",
        "group": "kantoor"
      }, {
        "identifier": "gebouw",
        "title": "Gebouw",
        "group": "kantoor"
      }, {
        "identifier": "kantoren",
        "title": "Kantoren",
        "group": "kantoor"
      }, {
        "identifier": "herenhuis",
        "title": "Herenhuis",
        "group": "kantoor"
      }, {
        "identifier": "gebouw_voor_gemengd_gebruik",
        "title": "Gebouw voor gemengd gebruik",
        "group": "kantoor"
      }, {
        "identifier": "villa",
        "title": "Villa",
        "group": "kantoor"
      }, {
        "identifier": "kantoorgebouw",
        "title": "Kantoorgebouw",
        "group": "kantoor"
      }, {
        "identifier": "overig",
        "title": "Overig",
        "group": "kantoor"
      }],
      "type": "dropdown_field",
      "identifier": "onroerend_goed_subtype"
    },
    "nieuwbouw": {
      "title": "Nieuwbouw",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "nee",
      "type": "segmented_control_field",
      "identifier": "nieuwbouw"
    },
    "bebouwing": {
      "title": "Bebouwing",
      "options": [{
        "identifier": "open",
        "title": "Open"
      }, {
        "identifier": "halfopen",
        "title": "Halfopen"
      }, {
        "identifier": "gesloten",
        "title": "Gesloten"
      }],
      "default": "gesloten",
      "type": "segmented_control_field",
      "identifier": "bebouwing"
    },
    "kadastrale_gegevens_beschikbaar": {
      "title": "Kadastrale gegevens",
      "options": [{
        "identifier": "ja",
        "title": "Beschikbaar"
      }, {
        "identifier": "nee",
        "title": "Niet beschikbaar"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "kadastrale_gegevens_beschikbaar"
    },
    "kadastrale_afdeling": {
      "title": "Afdeling",
      "type": "text_field",
      "identifier": "kadastrale_afdeling"
    },
    "kadastrale_sectie": {
      "title": "Sectie",
      "type": "text_field",
      "identifier": "kadastrale_sectie"
    },
    "kadastraal_nummer": {
      "title": "Nummer(s)",
      "type": "text_field",
      "identifier": "kadastraal_nummer"
    },
    "kadastraal_inkomen": {
      "title": "Kadastraal inkomen",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "kadastraal_inkomen"
    },
    "geindexeerd_ki": {
      "title": "Geïndexeerd KI",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "geindexeerd_ki"
    },
    "onroerende_voorheffing": {
      "title": "Onroerende voorheffing",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "onroerende_voorheffing"
    },
    "aantal_slaapkamers": {
      "title": "Aantal slaapkamers",
      "default": 1,
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_segmented_control_field",
      "identifier": "aantal_slaapkamers"
    },
    "aantal_badkamers": {
      "title": "Aantal badkamers",
      "default": 1,
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_segmented_control_field",
      "identifier": "aantal_badkamers"
    },
    "aantal_keukens": {
      "title": "Aantal keukens",
      "default": 1,
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_segmented_control_field",
      "identifier": "aantal_keukens"
    },
    "totaal_aantal_verdiepingen": {
      "title": "Totaal aantal verdiepingen",
      "default": 1,
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_segmented_control_field",
      "identifier": "totaal_aantal_verdiepingen"
    },
    "aannemer_ontwikkelaar": {
      "title": "Aannemer / ontwikkelaar",
      "options": [{
        "identifier": "volledig_zelf_gebouwd",
        "title": "Volledig zelf gebouwd"
      }, {
        "identifier": "gedeeltelijk_gebouwd",
        "title": "Gedeeltelijk gebouwd"
      }, {
        "identifier": "niet_meegedeeld",
        "title": "Niet meegedeeld"
      }, {
        "identifier": "andere",
        "title": "Andere"
      }],
      "type": "dropdown_field",
      "identifier": "aannemer_ontwikkelaar"
    },
    "aannemer_ontwikkelaar_andere": {
      "title": "Andere",
      "type": "text_field",
      "identifier": "aannemer_ontwikkelaar_andere"
    },
    "staat_van_het_eigendom": {
      "title": "Staat van het eigendom",
      "options": [{
        "identifier": "instapklaar",
        "title": "Instapklaar"
      }, {
        "identifier": "volledig_op_te_frissen",
        "title": "Volledig op te frissen"
      }, {
        "identifier": "gedeeltelijk_op_te_frisse",
        "title": "Gedeeltelijk op te frissen"
      }, {
        "identifier": "volledig_te_renoveren",
        "title": "Volledig te renoveren"
      }, {
        "identifier": "gedeeltelijk_te_renoveren",
        "title": "Gedeeltelijk te renoveren"
      }, {
        "identifier": "volledig_gerenoveerd",
        "title": "Volledig gerenoveerd"
      }, {
        "identifier": "gedeeltelijk_gerenoveerd",
        "title": "Gedeeltelijk gerenoveerd"
      }, {
        "identifier": "te_restaureren",
        "title": "Te restaureren"
      }, {
        "identifier": "gerestaureerd",
        "title": "Gerestaureerd"
      }, {
        "identifier": "af_te_werken",
        "title": "Af te werken"
      }, {
        "identifier": "af_te_breken",
        "title": "Af te breken"
      }, {
        "identifier": "andere",
        "title": "Andere"
      }],
      "default": "instapklaar",
      "type": "dropdown_field",
      "identifier": "staat_van_het_eigendom"
    },
    "staat_van_het_eigendom_andere": {
      "title": "Andere",
      "type": "text_field",
      "identifier": "staat_van_het_eigendom_andere"
    },
    "bouwjaar": {
      "title": "Bouwjaar",
      "precision": 0,
      "maximum": 2050,
      "type": "numeric_field",
      "identifier": "bouwjaar"
    },
    "renovaties_aanwezig": {
      "title": "Renovaties",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "renovaties_aanwezig"
    },
    "renovatiejaar": {
      "title": "Renovatiejaar",
      "precision": 0,
      "maximum": 2050,
      "type": "numeric_field",
      "identifier": "renovatiejaar"
    },
    "renovaties": {
      "subform": "renovatie",
      "title": "Voeg renovaties toe",
      "type": "builder_field",
      "identifier": "renovaties"
    },
    "type_ruwbouw": {
      "title": "Type",
      "options": [{
        "identifier": "traditioneel_metselwerk",
        "title": "Traditioneel metselwerk"
      }, {
        "identifier": "prefab_woning",
        "title": "Prefab woning"
      }, {
        "identifier": "staalconstructie",
        "title": "Staalconstructie"
      }, {
        "identifier": "houtskeletbouw",
        "title": "Houtskeletbouw"
      }, {
        "identifier": "gelijmd_metselwerk",
        "title": "Gelijmd metselwerk"
      }, {
        "identifier": "houtmassiefbouw",
        "title": "Houtmassiefbouw"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "default": "traditioneel_metselwerk",
      "type": "dropdown_field",
      "identifier": "type_ruwbouw"
    },
    "type_ruwbouw_overig": {
      "title": "Overig",
      "type": "text_field",
      "identifier": "type_ruwbouw_overig"
    },
    "vloerplaat_gelijkvloers_aanwezig": {
      "title": "Gelijkvloers",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "vloerplaat_gelijkvloers_aanwezig"
    },
    "vloerplaat_gelijkvloers_type": {
      "title": "Type",
      "options": [{
        "identifier": "gegoten_betonplaat",
        "title": "Gegoten betonplaat"
      }, {
        "identifier": "betonnen_welfsels",
        "title": "Betonnen welfsels"
      }, {
        "identifier": "houten_roostering",
        "title": "Houten roostering"
      }, {
        "identifier": "Potten en balken",
        "title": "Potten en balken"
      }, {
        "identifier": "onbekend",
        "title": "Onbekend"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "vloerplaat_gelijkvloers_type"
    },
    "vloerplaat_1e_verdieping_aanwezig": {
      "title": "Eerste verdieping",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "vloerplaat_1e_verdieping_aanwezig"
    },
    "vloerplaat_1e_verdieping_type": {
      "title": "Type",
      "options": [{
        "identifier": "gegoten_betonplaat",
        "title": "Gegoten betonplaat"
      }, {
        "identifier": "betonnen_welfsels",
        "title": "Betonnen welfsels"
      }, {
        "identifier": "houten_roostering",
        "title": "Houten roostering"
      }, {
        "identifier": "Potten en balken",
        "title": "Potten en balken"
      }, {
        "identifier": "onbekend",
        "title": "Onbekend"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "vloerplaat_1e_verdieping_type"
    },
    "vloerplaat_2e_verdieping_aanwezig": {
      "title": "Tweede verdieping",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "vloerplaat_2e_verdieping_aanwezig"
    },
    "vloerplaat_2e_verdieping_type": {
      "title": "Type",
      "options": [{
        "identifier": "gegoten_betonplaat",
        "title": "Gegoten betonplaat"
      }, {
        "identifier": "betonnen_welfsels",
        "title": "Betonnen welfsels"
      }, {
        "identifier": "houten_roostering",
        "title": "Houten roostering"
      }, {
        "identifier": "Potten en balken",
        "title": "Potten en balken"
      }, {
        "identifier": "onbekend",
        "title": "Onbekend"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "vloerplaat_2e_verdieping_type"
    },
    "vloerplaat_3e_verdieping_aanwezig": {
      "title": "Derde verdieping",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "vloerplaat_3e_verdieping_aanwezig"
    },
    "vloerplaat_3e_verdieping_type": {
      "title": "Type",
      "options": [{
        "identifier": "gegoten_betonplaat",
        "title": "Gegoten betonplaat"
      }, {
        "identifier": "betonnen_welfsels",
        "title": "Betonnen welfsels"
      }, {
        "identifier": "houten_roostering",
        "title": "Houten roostering"
      }, {
        "identifier": "Potten en balken",
        "title": "Potten en balken"
      }, {
        "identifier": "onbekend",
        "title": "Onbekend"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "vloerplaat_3e_verdieping_type"
    },
    "vloerplaat_4e_verdieping_aanwezig": {
      "title": "Vierde verdieping",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "vloerplaat_4e_verdieping_aanwezig"
    },
    "vloerplaat_4e_verdieping_type": {
      "title": "Type",
      "options": [{
        "identifier": "gegoten_betonplaat",
        "title": "Gegoten betonplaat"
      }, {
        "identifier": "betonnen_welfsels",
        "title": "Betonnen welfsels"
      }, {
        "identifier": "houten_roostering",
        "title": "Houten roostering"
      }, {
        "identifier": "Potten en balken",
        "title": "Potten en balken"
      }, {
        "identifier": "onbekend",
        "title": "Onbekend"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "vloerplaat_4e_verdieping_type"
    },
    "vloerplaat_5e_verdieping_aanwezig": {
      "title": "Vijfde verdieping",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "vloerplaat_5e_verdieping_aanwezig"
    },
    "vloerplaat_5e_verdieping_type": {
      "title": "Type",
      "options": [{
        "identifier": "gegoten_betonplaat",
        "title": "Gegoten betonplaat"
      }, {
        "identifier": "betonnen_welfsels",
        "title": "Betonnen welfsels"
      }, {
        "identifier": "houten_roostering",
        "title": "Houten roostering"
      }, {
        "identifier": "Potten en balken",
        "title": "Potten en balken"
      }, {
        "identifier": "onbekend",
        "title": "Onbekend"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "vloerplaat_5e_verdieping_type"
    },
    "vloerplaat_zolder_aanwezig": {
      "title": "Zolder",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "vloerplaat_zolder_aanwezig"
    },
    "vloerplaat_zolder_type": {
      "title": "Type",
      "options": [{
        "identifier": "gegoten_betonplaat",
        "title": "Gegoten betonplaat"
      }, {
        "identifier": "betonnen_welfsels",
        "title": "Betonnen welfsels"
      }, {
        "identifier": "houten_roostering",
        "title": "Houten roostering"
      }, {
        "identifier": "Potten en balken",
        "title": "Potten en balken"
      }, {
        "identifier": "onbekend",
        "title": "Onbekend"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "vloerplaat_zolder_type"
    },
    "dakconstructie_hoofdgebouw_type": {
      "title": "Hoofdgebouw",
      "options": [{
        "identifier": "zadeldak",
        "title": "Zadeldak"
      }, {
        "identifier": "schilddak",
        "title": "Schilddak"
      }, {
        "identifier": "mansardedak",
        "title": "Mansardedak"
      }, {
        "identifier": "wolfsdak",
        "title": "Wolfsdak"
      }, {
        "identifier": "plat_dak",
        "title": "Plat dak"
      }, {
        "identifier": "puntdak",
        "title": "Puntdak"
      }, {
        "identifier": "vlinderdak",
        "title": "Vlinderdak"
      }, {
        "identifier": "lessenaarsdak",
        "title": "Lessenaarsdak"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "dakconstructie_hoofdgebouw_type"
    },
    "dakconstructie_hoofdgebouw_grondstof": {
      "title": "Grondstof",
      "options": [{
        "identifier": "dubbele_roofing",
        "title": "Dubbele roofing"
      }, {
        "identifier": "epdm",
        "title": "EPDM"
      }, {
        "identifier": "pannen",
        "title": "Pannen"
      }, {
        "identifier": "riet",
        "title": "Riet"
      }, {
        "identifier": "zink",
        "title": "Zink"
      }, {
        "identifier": "leien",
        "title": "Leien"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "dakconstructie_hoofdgebouw_grondstof"
    },
    "bijgebouw_aanwezig": {
      "title": "Bijgebouw aanwezig",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "nee",
      "type": "segmented_control_field",
      "identifier": "bijgebouw_aanwezig"
    },
    "dakconstructie_bijgebouw_type": {
      "title": "Bijgebouw",
      "options": [{
        "identifier": "zadeldak",
        "title": "Zadeldak"
      }, {
        "identifier": "schilddak",
        "title": "Schilddak"
      }, {
        "identifier": "mansardedak",
        "title": "Mansardedak"
      }, {
        "identifier": "wolfsdak",
        "title": "Wolfsdak"
      }, {
        "identifier": "plat_dak",
        "title": "Plat dak"
      }, {
        "identifier": "puntdak",
        "title": "Puntdak"
      }, {
        "identifier": "vlinderdak",
        "title": "Vlinderdak"
      }, {
        "identifier": "lessenaarsdak",
        "title": "Lessenaarsdak"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "dakconstructie_bijgebouw_type"
    },
    "dakconstructie_bijgebouw_grondstof": {
      "title": "Grondstof",
      "options": [{
        "identifier": "dubbele_roofing",
        "title": "Dubbele roofing"
      }, {
        "identifier": "epdm",
        "title": "EPDM"
      }, {
        "identifier": "pannen",
        "title": "Pannen"
      }, {
        "identifier": "riet",
        "title": "Riet"
      }, {
        "identifier": "zink",
        "title": "Zink"
      }, {
        "identifier": "leien",
        "title": "Leien"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "dakconstructie_bijgebouw_grondstof"
    },
    "aanbouw_aanwezig": {
      "title": "Aanbouw aanwezig",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "nee",
      "type": "segmented_control_field",
      "identifier": "aanbouw_aanwezig"
    },
    "dakconstructie_aanbouw_type": {
      "title": "Aanbouw",
      "options": [{
        "identifier": "zadeldak",
        "title": "Zadeldak"
      }, {
        "identifier": "schilddak",
        "title": "Schilddak"
      }, {
        "identifier": "mansardedak",
        "title": "Mansardedak"
      }, {
        "identifier": "wolfsdak",
        "title": "Wolfsdak"
      }, {
        "identifier": "plat_dak",
        "title": "Plat dak"
      }, {
        "identifier": "puntdak",
        "title": "Puntdak"
      }, {
        "identifier": "vlinderdak",
        "title": "Vlinderdak"
      }, {
        "identifier": "lessenaarsdak",
        "title": "Lessenaarsdak"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "dakconstructie_aanbouw_type"
    },
    "dakconstructie_aanbouw_grondstof": {
      "title": "Grondstof",
      "options": [{
        "identifier": "dubbele_roofing",
        "title": "Dubbele roofing"
      }, {
        "identifier": "epdm",
        "title": "EPDM"
      }, {
        "identifier": "pannen",
        "title": "Pannen"
      }, {
        "identifier": "riet",
        "title": "Riet"
      }, {
        "identifier": "zink",
        "title": "Zink"
      }, {
        "identifier": "leien",
        "title": "Leien"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "dakconstructie_aanbouw_grondstof"
    },
    "epc_aanwezig": {
      "title": "EPC aanwezig",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }, {
        "identifier": "niet_gekend",
        "title": "Niet gekend"
      }],
      "default": "niet_gekend",
      "type": "segmented_control_field",
      "identifier": "epc_aanwezig"
    },
    "epc_waarde": {
      "title": "EPC waarde",
      "precision": 0,
      "type": "numeric_field",
      "identifier": "epc_waarde"
    },
    "muurisolatie": {
      "title": "Muur",
      "options": [{
        "identifier": "spouwmuur",
        "title": "Spouwmuur"
      }, {
        "identifier": "steense_muur",
        "title": "Steense muur"
      }, {
        "identifier": "dubbele_spouw",
        "title": "Dubbele spouw"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "muurisolatie"
    },
    "muurisolatie_overig": {
      "title": "Overig",
      "type": "text_field",
      "identifier": "muurisolatie_overig"
    },
    "vloerisolatie_aanwezig": {
      "title": "Vloerisolatie",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "vloerisolatie_aanwezig"
    },
    "vloerisolatie_type": {
      "title": "Type",
      "options": [{
        "identifier": "todo",
        "title": "Nader te bepalen"
      }],
      "type": "dropdown_field",
      "identifier": "vloerisolatie_type"
    },
    "dakisolatie_aanwezig": {
      "title": "Dakisolatie",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "dakisolatie_aanwezig"
    },
    "dakisolatie_type": {
      "title": "Type",
      "options": [{
        "identifier": "todo",
        "title": "Nader te bepalen"
      }],
      "type": "dropdown_field",
      "identifier": "dakisolatie_type"
    },
    "zolderplaat_aanwezig": {
      "title": "Zolderplaat",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "ja",
      "type": "segmented_control_field",
      "identifier": "zolderplaat_aanwezig"
    },
    "zolderplaat_type": {
      "title": "Type",
      "options": [{
        "identifier": "todo",
        "title": "Nader te bepalen"
      }],
      "type": "dropdown_field",
      "identifier": "zolderplaat_type"
    },
    "buitenschrijnwerk_type": {
      "title": "Type",
      "options": [{
        "identifier": "aluminium",
        "title": "Aluminium"
      }, {
        "identifier": "hout",
        "title": "Hout"
      }, {
        "identifier": "hardhout",
        "title": "Hardhout"
      }, {
        "identifier": "pvc",
        "title": "PVC"
      }, {
        "identifier": "staal",
        "title": "Staal"
      }, {
        "identifier": "gedeelte_aluminium",
        "title": "Gedeelte aluminium"
      }, {
        "identifier": "gedeelte_hout",
        "title": "Gedeelte hout"
      }, {
        "identifier": "gedeelte_hardhout",
        "title": "Gedeelte hardhout"
      }, {
        "identifier": "gedeelte_pvc",
        "title": "Gedeelte PVC"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "multi_checkbox_field",
      "identifier": "buitenschrijnwerk_type"
    },
    "buitenschrijnwerk_beglazing": {
      "title": "Beglazing",
      "options": [{
        "identifier": "volledig_dubbele_beglazing",
        "title": "Volledig dubbele beglazing"
      }, {
        "identifier": "volledig_enkele_beglazing",
        "title": "Volledig enkele beglazing"
      }, {
        "identifier": "veiligheidsglas",
        "title": "Veiligheidsglas"
      }, {
        "identifier": "gedeelte_dubbele_beglazing",
        "title": "Gedeelte dubbele beglazing"
      }, {
        "identifier": "gedeelte_enkele_beglazing",
        "title": "Gedeelte enkele beglazing"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "multi_checkbox_field",
      "identifier": "buitenschrijnwerk_beglazing"
    },
    "buitenschrijnwerk_luiken": {
      "title": "Luiken",
      "options": [{
        "identifier": "sierluiken",
        "title": "Sierluiken"
      }, {
        "identifier": "rolluiken",
        "title": "Rolluiken"
      }, {
        "identifier": "functionele_luiken",
        "title": "Functionele luiken"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "multi_checkbox_field",
      "identifier": "buitenschrijnwerk_luiken"
    },
    "type_verwarming": {
      "title": "Type verwarming",
      "options": [{
        "identifier": "centrale_verwarming",
        "title": "Centrale verwarming"
      }, {
        "identifier": "individuele_verwarming",
        "title": "Individuele verwarming"
      }, {
        "identifier": "geen_verwarming",
        "title": "Geen verwarming"
      }, {
        "identifier": "gemeenschappelijke_verwarming",
        "title": "Gemeenschappelijke verwarming"
      }, {
        "identifier": "collectieve_verwarming",
        "title": "Collectieve verwarming"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "type_verwarming"
    },
    "type_verwarming_overig": {
      "placeholder": "Overig",
      "type": "text_field",
      "identifier": "type_verwarming_overig"
    },
    "verwarmingsinstallatie": {
      "title": "Verwarmingsinstallatie",
      "options": [{
        "identifier": "nee",
        "title": "Nee"
      }, {
        "identifier": "buderus",
        "title": "Ja - Buderus"
      }, {
        "identifier": "vaillant",
        "title": "Ja - Vaillant"
      }, {
        "identifier": "wolf",
        "title": "Ja - Wolf"
      }, {
        "identifier": "atag",
        "title": "Ja - ATAG"
      }, {
        "identifier": "daalderop",
        "title": "Ja - Daalderop"
      }, {
        "identifier": "junkers",
        "title": "Ja - Junkers"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "verwarmingsinstallatie"
    },
    "verwarmingsinstallatie_overig": {
      "placeholder": "Overig",
      "type": "text_field",
      "identifier": "verwarmingsinstallatie_overig"
    },
    "grondstof_verwarming": {
      "title": "Grondstof verwarming",
      "options": [{
        "identifier": "aardgas",
        "title": "Aardgas"
      }, {
        "identifier": "zonnepanelen",
        "title": "Zonnepanelen"
      }, {
        "identifier": "elektriciteit",
        "title": "Elektriciteit"
      }, {
        "identifier": "hout",
        "title": "Hout"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }, {
        "identifier": "stookolie",
        "title": "Stookolie"
      }, {
        "identifier": "warmtepomp",
        "title": "Warmtepomp"
      }, {
        "identifier": "kolen",
        "title": "Kolen"
      }, {
        "identifier": "propaangas",
        "title": "Propaangas"
      }],
      "type": "multi_checkbox_field",
      "identifier": "grondstof_verwarming"
    },
    "bron_van_verwarming": {
      "title": "Bron van verwarming",
      "options": [{
        "identifier": "radiatoren",
        "title": "Radiatoren"
      }, {
        "identifier": "vloerverwarming",
        "title": "Vloerverwarming"
      }, {
        "identifier": "accumulatiekachels",
        "title": "Accumulatiekachels"
      }, {
        "identifier": "radiatoren_thermische_kranen",
        "title": "Radiatoren thermische kranen"
      }, {
        "identifier": "convectoren",
        "title": "Convectoren"
      }, {
        "identifier": "warme_lucht",
        "title": "Warme lucht"
      }, {
        "identifier": "kachels",
        "title": "Kachels"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "multi_checkbox_field",
      "identifier": "bron_van_verwarming"
    },
    "warmwatervoorziening_type": {
      "title": "Warmwatervoorziening",
      "options": [{
        "identifier": "nee",
        "title": "Nee"
      }, {
        "identifier": "buderus",
        "title": "Ja - Buderus"
      }, {
        "identifier": "vaillant",
        "title": "Ja - Vaillant"
      }, {
        "identifier": "wolf",
        "title": "Ja - Wolf"
      }, {
        "identifier": "atag",
        "title": "Ja - ATAG"
      }, {
        "identifier": "daalderop",
        "title": "Ja - Daalderop"
      }, {
        "identifier": "junkers",
        "title": "Ja - Junkers"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "warmwatervoorziening_type"
    },
    "warmwatervoorziening_type_overig": {
      "placeholder": "Overig",
      "type": "text_field",
      "identifier": "warmwatervoorziening_type_overig"
    },
    "extra_warmwatervoorziening_type": {
      "title": "Extra warmwatervoorziening",
      "options": [{
        "identifier": "nee",
        "title": "Nee"
      }, {
        "identifier": "buderus",
        "title": "Ja - Buderus"
      }, {
        "identifier": "vaillant",
        "title": "Ja - Vaillant"
      }, {
        "identifier": "wolf",
        "title": "Ja - Wolf"
      }, {
        "identifier": "atag",
        "title": "Ja - ATAG"
      }, {
        "identifier": "daalderop",
        "title": "Ja - Daalderop"
      }, {
        "identifier": "junkers",
        "title": "Ja - Junkers"
      }, {
        "identifier": "overig",
        "title": "Overig"
      }],
      "type": "dropdown_field",
      "identifier": "extra_warmwatervoorziening_type"
    },
    "extra_warmwatervoorziening_type_overig": {
      "placeholder": "Overig",
      "type": "text_field",
      "identifier": "extra_warmwatervoorziening_type_overig"
    },
    "zonnepanelen_locatie": {
      "title": "Zonnepanelen",
      "placeholder": "Voer een locatie in",
      "type": "text_field",
      "identifier": "zonnepanelen_locatie"
    },
    "vloerverwarming_locatie": {
      "title": "Vloerverwarming",
      "placeholder": "Voer een locatie in",
      "type": "text_field",
      "identifier": "vloerverwarming_locatie"
    },
    "elektrische_installatie_conform": {
      "title": "Elektrische installatie conform",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }, {
        "identifier": "niet_gekend",
        "title": "Niet gekend"
      }],
      "default": "niet_gekend",
      "type": "segmented_control_field",
      "identifier": "elektrische_installatie_conform"
    },
    "alarminstallatie_aanwezig": {
      "title": "Alarminstallatie",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "nee",
      "type": "segmented_control_field",
      "identifier": "alarminstallatie_aanwezig"
    },
    "alarminstallatie_type": {
      "title": "Type",
      "type": "text_field",
      "identifier": "alarminstallatie_type"
    },
    "zonnescherm_screens": {
      "title": "Zonnescherm / screens",
      "options": [{
        "identifier": "handmatig",
        "title": "Ja, handmatig"
      }, {
        "identifier": "elektrisch",
        "title": "Ja, elektrisch"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "nee",
      "type": "segmented_control_field",
      "identifier": "zonnescherm_screens"
    },
    "type_installaties": {
      "title": "Type installaties",
      "options": [{
        "identifier": "gashaard",
        "title": "Gashaard"
      }, {
        "identifier": "schotelantenne",
        "title": "Schotelantenne"
      }, {
        "identifier": "domotica",
        "title": "Domotica"
      }, {
        "identifier": "parlofoon",
        "title": "Parlofoon"
      }, {
        "identifier": "aansluiting_alarminstallatie",
        "title": "Aansluiting alarminstallatie"
      }, {
        "identifier": "videobewaking",
        "title": "Videobewaking"
      }, {
        "identifier": "airconditioning",
        "title": "Airconditioning"
      }, {
        "identifier": "automatische_toegangspoort",
        "title": "Automatische toegangspoort"
      }, {
        "identifier": "sproei_installatie",
        "title": "Sproei-installatie"
      }, {
        "identifier": "lift",
        "title": "Lift"
      }, {
        "identifier": "videofoon",
        "title": "Videofoon"
      }, {
        "identifier": "veiligheidsdeur",
        "title": "Veiligheidsdeur"
      }, {
        "identifier": "aansluiting_videobewaking",
        "title": "Aansluiting videobewaking"
      }],
      "type": "multi_checkbox_field",
      "identifier": "type_installaties"
    },
    "installatie_extras": {
      "title": "Extra's",
      "options": [{
        "identifier": "veranda_serre",
        "title": "Veranda / serre"
      }, {
        "identifier": "sauna",
        "title": "Sauna"
      }, {
        "identifier": "binnenzwembad",
        "title": "Binnenzwembad"
      }, {
        "identifier": "jacuzzi",
        "title": "Jacuzzi"
      }],
      "type": "multi_checkbox_field",
      "identifier": "installatie_extras"
    },
    "aantal_inpandige_garages": {
      "title": "Aantal inpandige garages",
      "default": 0,
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_segmented_control_field",
      "identifier": "aantal_inpandige_garages"
    },
    "aantal_uitpandige_garages": {
      "title": "Aantal uitpandige garages",
      "default": 0,
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_segmented_control_field",
      "identifier": "aantal_uitpandige_garages"
    },
    "garages_eigenschappen": {
      "title": "Eigenschappen",
      "options": [{
        "identifier": "automatische_poort",
        "title": "Automatische poort"
      }, {
        "identifier": "handmatige_poort",
        "title": "Handmatige poort"
      }, {
        "identifier": "kantelpoort",
        "title": "Kantelpoort"
      }, {
        "identifier": "sectional_poort",
        "title": "Sectionale poort"
      }, {
        "identifier": "draaideuren",
        "title": "Draaideuren"
      }],
      "type": "multi_checkbox_field",
      "identifier": "garages_eigenschappen"
    },
    "garages_aansluitingen": {
      "title": "Aansluitingen",
      "options": [{
        "identifier": "220v_elektriciteit",
        "title": "220V elektriciteit"
      }, {
        "identifier": "380v_elektriciteit",
        "title": "380V elektriciteit"
      }, {
        "identifier": "verwarming",
        "title": "Verwarming"
      }, {
        "identifier": "water",
        "title": "Water"
      }],
      "type": "multi_checkbox_field",
      "identifier": "garages_aansluitingen"
    },
    "aantal_staanplaatsen": {
      "title": "Aantal staanplaatsen",
      "default": 0,
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_segmented_control_field",
      "identifier": "aantal_staanplaatsen"
    },
    "aantal_parkeerplaatsen": {
      "title": "Aantal parkeerplaatsen",
      "default": 0,
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_segmented_control_field",
      "identifier": "aantal_parkeerplaatsen"
    },
    "kelderverdieping_aanwezig": {
      "title": "Kelder aanwezig",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "nee",
      "type": "segmented_control_field",
      "identifier": "kelderverdieping_aanwezig"
    },
    "kelderverdieping_type": {
      "title": "Type kelderverdieping",
      "options": [{
        "identifier": "deels_onderkelderd",
        "title": "Deels onderkelderd"
      }, {
        "identifier": "deels_kruipkelder",
        "title": "Deels kruipkelder"
      }, {
        "identifier": "inpandige_garage",
        "title": "Inpandige garage"
      }, {
        "identifier": "volledig_onderkelderd",
        "title": "Volledig onderkelderd"
      }, {
        "identifier": "volledige_kruipruimte",
        "title": "Volledige kruipruimte"
      }, {
        "identifier": "inpandige_kelder",
        "title": "Inpandige kelder"
      }],
      "type": "multi_checkbox_field",
      "identifier": "kelderverdieping_type"
    },
    "zolderverdieping_aanwezig": {
      "title": "Zolderverdieping aanwezig",
      "options": [{
        "identifier": "bergzolder",
        "title": "Ja, bergzolder"
      }, {
        "identifier": "ingerichte_zolder",
        "title": "Ja, ingerichte zolder"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "nee",
      "type": "segmented_control_field",
      "identifier": "zolderverdieping_aanwezig"
    },
    "zolderverdieping_trap": {
      "title": "Trap",
      "options": [{
        "identifier": "vaste_trap",
        "title": "Vaste trap"
      }, {
        "identifier": "vlizotrap",
        "title": "Vlizotrap"
      }, {
        "identifier": "luikje",
        "title": "Luikje"
      }],
      "default": "vaste_trap",
      "type": "segmented_control_field",
      "identifier": "zolderverdieping_trap"
    },
    "tuin_aanwezig": {
      "title": "Tuin aanwezig",
      "options": [{
        "identifier": "ja",
        "title": "Ja"
      }, {
        "identifier": "nee",
        "title": "Nee"
      }],
      "default": "nee",
      "type": "segmented_control_field",
      "identifier": "tuin_aanwezig"
    },
    "tuin_orientatie": {
      "title": "Oriëntatie",
      "options": [{
        "identifier": "noorden",
        "title": "Noorden"
      }, {
        "identifier": "noord_oosten",
        "title": "Noord-oosten"
      }, {
        "identifier": "oosten",
        "title": "Oosten"
      }, {
        "identifier": "zuid_oosten",
        "title": "Zuid-oosten"
      }, {
        "identifier": "zuiden",
        "title": "Zuiden"
      }, {
        "identifier": "zuid_westen",
        "title": "Zuid-westen"
      }, {
        "identifier": "westen",
        "title": "Westen"
      }, {
        "identifier": "noord_westen",
        "title": "Noord-westen"
      }],
      "type": "dropdown_field",
      "identifier": "tuin_orientatie"
    },
    "tuin_zwembad": {
      "title": "Zwembad",
      "options": [{
        "identifier": "geen",
        "title": "Geen"
      }, {
        "identifier": "verwarmd",
        "title": "Verwarmd"
      }, {
        "identifier": "overdekt",
        "title": "Overdekt"
      }, {
        "identifier": "verwarmd_en_overdekt",
        "title": "Verwarmd en overdekt"
      }],
      "type": "dropdown_field",
      "identifier": "tuin_zwembad"
    },
    "tuin_extras": {
      "title": "Tuin extra's",
      "options": [{
        "identifier": "aangelegd",
        "title": "Aangelegd"
      }, {
        "identifier": "volledig_omheind",
        "title": "Volledig omheind"
      }, {
        "identifier": "vijver",
        "title": "Vijver"
      }, {
        "identifier": "jacuzzi",
        "title": "Jacuzzi"
      }, {
        "identifier": "terras",
        "title": "Terras"
      }, {
        "identifier": "tuinhuis",
        "title": "Tuinhuis"
      }, {
        "identifier": "tennisveld",
        "title": "Tennisveld"
      }],
      "type": "multi_checkbox_field",
      "identifier": "tuin_extras"
    },
    "nutsvoorzieningen": {
      "title": "Nutsvoorzieningen",
      "options": [{
        "identifier": "elektriciteit",
        "title": "Elektriciteit"
      }, {
        "identifier": "water",
        "title": "Water"
      }, {
        "identifier": "telefoon",
        "title": "Telefoon"
      }, {
        "identifier": "kabeldistributie",
        "title": "Kabeldistributie"
      }, {
        "identifier": "regenwaterput",
        "title": "Regenwaterput"
      }, {
        "identifier": "septische_put",
        "title": "Septische put"
      }, {
        "identifier": "aardgas",
        "title": "Aardgas"
      }, {
        "identifier": "riolering",
        "title": "Riolering"
      }, {
        "identifier": "internet",
        "title": "Internet"
      }, {
        "identifier": "aardgas_in_de_straat",
        "title": "Aardgas in de straat"
      }, {
        "identifier": "grondwaterput",
        "title": "Grondwaterput"
      }],
      "type": "multi_checkbox_field",
      "identifier": "nutsvoorzieningen"
    },
    "gunstige_factoren": {
      "subform": "waardebeinvloedende_factor",
      "title": "Gunstige factoren",
      "type": "builder_field",
      "identifier": "gunstige_factoren"
    },
    "ongunstige_factoren": {
      "subform": "waardebeinvloedende_factor",
      "title": "Ongunstige factoren",
      "type": "builder_field",
      "identifier": "ongunstige_factoren"
    },
    "straatbreedte": {
      "title": "Straatbreedte",
      "precision": 2,
      "unit": "m",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "straatbreedte"
    },
    "diepte_breedte_verhouding": {
      "title": "Diepte-breedte verhouding",
      "type": "text_field",
      "identifier": "diepte_breedte_verhouding"
    },
    "grondoppervlakte": {
      "title": "Grondoppervlakte",
      "precision": 2,
      "unit": "m²",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "grondoppervlakte"
    },
    "oppervlakte_aanpalende_grond": {
      "title": "Oppervlakte aanpalende grond",
      "precision": 2,
      "unit": "m²",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "oppervlakte_aanpalende_grond"
    },
    "grondprijs_min": {
      "title": "Grondprijs min",
      "precision": 2,
      "unit": "€/m²",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "grondprijs_min"
    },
    "grondprijs_max": {
      "title": "Grondprijs max",
      "precision": 2,
      "unit": "€/m²",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "grondprijs_max"
    },
    "grondprijs_gemiddeld": {
      "title": "Grondprijs gemiddeld",
      "precision": 2,
      "unit": "€/m²",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "grondprijs_gemiddeld"
    },
    "aantal_m2_aan_volle_waarde_meters": {
      "title": "Aantal m² aan volle waarde",
      "precision": 2,
      "unit": "m²",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "aantal_m2_aan_volle_waarde_meters"
    },
    "aantal_m2_aan_volle_waarde_factor": {
      "title": "Factor",
      "default": 100,
      "precision": 2,
      "unit": "%",
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_field",
      "identifier": "aantal_m2_aan_volle_waarde_factor"
    },
    "aantal_m2_aan_volle_waarde_bedrag": {
      "title": "Bedrag",
      "precision": 2,
      "unit": "€",
      "disabled": true,
      "type": "numeric_field",
      "identifier": "aantal_m2_aan_volle_waarde_bedrag"
    },
    "aantal_m2_verhouding_3_1_meters": {
      "title": "Aantal m\xB2 > verhouding 3/1",
      "precision": 2,
      "unit": "m²",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "aantal_m2_verhouding_3_1_meters"
    },
    "aantal_m2_verhouding_3_1_factor": {
      "title": "Factor",
      "default": 100,
      "precision": 2,
      "unit": "%",
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_field",
      "identifier": "aantal_m2_verhouding_3_1_factor"
    },
    "aantal_m2_verhouding_3_1_bedrag": {
      "title": "Bedrag",
      "precision": 2,
      "unit": "€",
      "disabled": true,
      "type": "numeric_field",
      "identifier": "aantal_m2_verhouding_3_1_bedrag"
    },
    "grondwaarde_perceel": {
      "title": "Grondwaarde perceel",
      "precision": 2,
      "unit": "€",
      "disabled": true,
      "type": "numeric_field",
      "identifier": "grondwaarde_perceel"
    },
    "reductie_percentage_bebouwd_perceel": {
      "title": "Reductie % bebouwd perceel",
      "default": 15,
      "precision": 2,
      "unit": "%",
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_field",
      "identifier": "reductie_percentage_bebouwd_perceel"
    },
    "reductie_percentage_bebouwd_perceel_bedrag": {
      "title": "Bedrag",
      "precision": 2,
      "unit": "€",
      "disabled": true,
      "type": "numeric_field",
      "identifier": "reductie_percentage_bebouwd_perceel_bedrag"
    },
    "grondprijs_perceel_na_correctie": {
      "title": "Grondprijs perceel na correctie",
      "precision": 2,
      "unit": "€/m²",
      "disabled": true,
      "type": "numeric_field",
      "identifier": "grondprijs_perceel_na_correctie"
    },
    "aanpalende_grond": {
      "title": "Aanpalende grond",
      "precision": 2,
      "unit": "€/m²",
      "type": "numeric_field",
      "identifier": "aanpalende_grond"
    },
    "aanpalende_grond_totaal": {
      "title": "Bedrag",
      "precision": 2,
      "unit": "€",
      "disabled": true,
      "type": "numeric_field",
      "identifier": "aanpalende_grond_totaal"
    },
    "waardeberekening_perceel_totaal": {
      "title": "Totaal",
      "precision": 2,
      "unit": "€",
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_perceel_totaal"
    },
    "vloerplaatprijs_min": {
      "title": "Vloerplaatprijs min",
      "precision": 2,
      "unit": "€/m²",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "vloerplaatprijs_min"
    },
    "vloerplaatprijs_max": {
      "title": "Vloerplaatprijs max",
      "precision": 2,
      "unit": "€/m²",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "vloerplaatprijs_max"
    },
    "vloerplaatprijs_gemiddeld": {
      "title": "Vloerplaatprijs gemiddeld",
      "precision": 2,
      "unit": "€/m²",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "vloerplaatprijs_gemiddeld"
    },
    "totaal_bebouwbare_oppervlakte": {
      "title": "Totaal bebouwbare oppervlakte",
      "precision": 2,
      "unit": "m²",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "totaal_bebouwbare_oppervlakte"
    },
    "ruimtespecificatie": {
      "subform": "ruimte",
      "title": "Oppervlakteberekening",
      "type": "builder_field",
      "identifier": "ruimtespecificatie"
    },
    "totaal_bewoonbare_oppervlakte": {
      "title": "Totaal bewoonbare oppervlakte",
      "precision": 2,
      "unit": "m²",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "totaal_bewoonbare_oppervlakte"
    },
    "waarde_in_vloerplaatprijs": {
      "title": "Waarde in vloerplaatprijs",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waarde_in_vloerplaatprijs"
    },
    "referentiejaar": {
      "title": "Referentiejaar",
      "default": 2018,
      "precision": 0,
      "maximum": 2050,
      "type": "numeric_field",
      "identifier": "referentiejaar"
    },
    "renovatiepercentage": {
      "title": "Renovatiepercentage",
      "default": 50,
      "precision": 2,
      "unit": "%",
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_field",
      "identifier": "renovatiepercentage"
    },
    "vetusteit_ouderdom_jaren": {
      "title": "Aantal jaren voor vetusteit ouderdom",
      "precision": 2,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "vetusteit_ouderdom_jaren"
    },
    "vetusteit_ouderdom_percentage": {
      "title": "Vetusteit ouderdom",
      "precision": 2,
      "unit": "%",
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_field",
      "identifier": "vetusteit_ouderdom_percentage"
    },
    "vetusteit_gebruik": {
      "title": "Vetusteit gebruik",
      "default": 2,
      "precision": 2,
      "unit": "%",
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_field",
      "identifier": "vetusteit_gebruik"
    },
    "vetusteit_onderhoud": {
      "title": "Vetusteit onderhoud",
      "default": 8,
      "precision": 2,
      "unit": "%",
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_field",
      "identifier": "vetusteit_onderhoud"
    },
    "waardeberekening_constructies_totaal": {
      "title": "Totaal",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_constructies_totaal"
    },
    "waardeberekening_grond_min": {
      "title": "Grond min",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_grond_min"
    },
    "waardeberekening_grond_max": {
      "title": "Grond max",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_grond_max"
    },
    "waardeberekening_aanpalende_grond_min": {
      "title": "Aanpalende grond min",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_aanpalende_grond_min"
    },
    "waardeberekening_aanpalende_grond_max": {
      "title": "Aanpalende grond max",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_aanpalende_grond_max"
    },
    "waardeberekening_constructie_min": {
      "title": "Constructie min",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_constructie_min"
    },
    "waardeberekening_constructie_max": {
      "title": "Constructie max",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_constructie_max"
    },
    "waardeberekening_subtotaal_1_min": {
      "title": "Subtotaal min",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_subtotaal_1_min"
    },
    "waardeberekening_subtotaal_1_max": {
      "title": "Subtotaal max",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_subtotaal_1_max"
    },
    "waardeberekening_vetusteit": {
      "title": "Vetusteit",
      "precision": 2,
      "unit": "%",
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_field",
      "identifier": "waardeberekening_vetusteit"
    },
    "waardeberekening_vetusteit_min": {
      "title": "Vetusteit min",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_vetusteit_min"
    },
    "waardeberekening_vetusteit_max": {
      "title": "Vetusteit max",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_vetusteit_max"
    },
    "waardeberekening_subtotaal_2_min": {
      "title": "Subtotaal min",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_subtotaal_2_min"
    },
    "waardeberekening_subtotaal_2_max": {
      "title": "Subtotaal max",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_subtotaal_2_max"
    },
    "economische_meerwaarde_factor": {
      "title": "Economische meerwaarde",
      "precision": 2,
      "unit": "%",
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_field",
      "identifier": "economische_meerwaarde_factor"
    },
    "economische_meerwaarde_min": {
      "title": "Meerwaarde min",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "economische_meerwaarde_min"
    },
    "economische_meerwaarde_max": {
      "title": "Meerwaarde max",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "economische_meerwaarde_max"
    },
    "economische_minwaarde_factor": {
      "title": "Economische minwaarde",
      "precision": 2,
      "unit": "%",
      "minimum": 0,
      "maximum": 100,
      "type": "numeric_field",
      "identifier": "economische_minwaarde_factor"
    },
    "economische_minwaarde_min": {
      "title": "Minwaarde min",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "economische_minwaarde_min"
    },
    "economische_minwaarde_max": {
      "title": "Minwaarde max",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "economische_minwaarde_max"
    },
    "waardeberekening_subtotaal_3_min": {
      "title": "Totaal min",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_subtotaal_3_min"
    },
    "waardeberekening_subtotaal_3_max": {
      "title": "Totaal max",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "waardeberekening_subtotaal_3_max"
    },
    "intrinsieke_waarde": {
      "title": "Intrinsieke waarde",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "disabled": true,
      "type": "numeric_field",
      "identifier": "intrinsieke_waarde"
    },
    "adviesprijs_makelaar_type": {
      "title": "Adviesprijs makelaar",
      "options": [{
        "identifier": "in_overleg",
        "title": "In overleg"
      }, {
        "identifier": "prijs_tonen",
        "title": "Prijs tonen"
      }],
      "default": "prijs_tonen",
      "type": "segmented_control_field",
      "identifier": "adviesprijs_makelaar_type"
    },
    "adviesprijs_makelaar_bedrag": {
      "title": "Prijs",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "adviesprijs_makelaar_bedrag"
    },
    "eindconclusie_opgemaakt_voor": {
      "title": "Dit verslag werd opgemaakt voor",
      "disabled": true,
      "type": "text_field",
      "identifier": "eindconclusie_opgemaakt_voor"
    },
    "eindconclusie_gelegen_aan": {
      "title": "Gelegen aan het",
      "disabled": true,
      "type": "text_field",
      "identifier": "eindconclusie_gelegen_aan"
    },
    "eindconclusie_rekening_gehouden_met": {
      "title": "In deze schatting is o.a. rekening gehouden met",
      "placeholder": "Persoonlijke tekst makelaar over o.a.:\n\n - verkoopbaarheid met voornaamste redenen\n - uitzicht\n - onderhoud/staat",
      "type": "text_area_field",
      "identifier": "eindconclusie_rekening_gehouden_met"
    },
    "eindconclusie_marktwaarde": {
      "title": "Marktwaarde",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "eindconclusie_marktwaarde"
    },
    "eindconclusie_maximale_vraagprijs": {
      "title": "Maximale vraagprijs",
      "precision": 2,
      "unit": "€",
      "minimum": 0,
      "type": "numeric_field",
      "identifier": "eindconclusie_maximale_vraagprijs"
    },
    "fotos": {
      "type": "immo_taxation_report_photos_field",
      "identifier": "fotos"
    }
  },
  "rules": {
    "te_schatten_eigendom.visible": {
      "target_identifier": "te_schatten_eigendom",
      "target_property": "visible",
      "expression": ["equals", ["read", "adresgegevens_gelijk_aan_te_schatten_eigendom"], "nee"]
    },
    "onroerend_goed_subtype.group": {
      "target_identifier": "onroerend_goed_subtype",
      "target_property": "group",
      "expression": ["read", "onroerend_goed_type"]
    },
    "kadastrale_gegevens.visible": {
      "target_identifier": "kadastrale_gegevens",
      "target_property": "visible",
      "expression": ["equals", ["read", "kadastrale_gegevens_beschikbaar"], "ja"]
    },
    "staat_van_het_eigendom_andere.visible": {
      "target_identifier": "staat_van_het_eigendom_andere",
      "target_property": "visible",
      "expression": ["equals", ["read", "staat_van_het_eigendom"], "andere"]
    },
    "dakconstructie_bijgebouw.visible": {
      "target_identifier": "dakconstructie_bijgebouw",
      "target_property": "visible",
      "expression": ["equals", ["read", "bijgebouw_aanwezig"], "ja"]
    },
    "dakconstructie_aanbouw.visible": {
      "target_identifier": "dakconstructie_aanbouw",
      "target_property": "visible",
      "expression": ["equals", ["read", "aanbouw_aanwezig"], "ja"]
    },
    "vloerisolatie_type.visible": {
      "target_identifier": "vloerisolatie_type",
      "target_property": "visible",
      "expression": ["equals", ["read", "vloerisolatie_aanwezig"], "ja"]
    },
    "dakisolatie_type.visible": {
      "target_identifier": "dakisolatie_type",
      "target_property": "visible",
      "expression": ["equals", ["read", "dakisolatie_aanwezig"], "ja"]
    },
    "zolderplaat_type.visible": {
      "target_identifier": "zolderplaat_type",
      "target_property": "visible",
      "expression": ["equals", ["read", "zolderplaat_aanwezig"], "ja"]
    },
    "alarminstallatie_type.visible": {
      "target_identifier": "alarminstallatie_type",
      "target_property": "visible",
      "expression": ["equals", ["read", "alarminstallatie_aanwezig"], "ja"]
    },
    "kelderverdieping_type.visible": {
      "target_identifier": "kelderverdieping_type",
      "target_property": "visible",
      "expression": ["equals", ["read", "kelderverdieping_aanwezig"], "ja"]
    },
    "epc_waarde.visible": {
      "target_identifier": "epc_waarde",
      "target_property": "visible",
      "expression": ["equals", ["read", "epc_aanwezig"], "ja"]
    },
    "zolderverdieping_trap.visible": {
      "target_identifier": "zolderverdieping_trap",
      "target_property": "visible",
      "expression": ["not_equals", ["read", "zolderverdieping_aanwezig"], "nee"]
    },
    "tuin_details.visible": {
      "target_identifier": "tuin_details",
      "target_property": "visible",
      "expression": ["equals", ["read", "tuin_aanwezig"], "ja"]
    },
    "type_ruwbouw_overig.visible": {
      "target_identifier": "type_ruwbouw_overig",
      "target_property": "visible",
      "expression": ["equals", ["read", "type_ruwbouw"], "overig"]
    },
    "muurisolatie_overig.visible": {
      "target_identifier": "muurisolatie_overig",
      "target_property": "visible",
      "expression": ["equals", ["read", "muurisolatie"], "overig"]
    },
    "type_verwarming_overig.visible": {
      "target_identifier": "type_verwarming_overig",
      "target_property": "visible",
      "expression": ["equals", ["read", "type_verwarming"], "overig"]
    },
    "verwarmingsinstallatie_overig.visible": {
      "target_identifier": "verwarmingsinstallatie_overig",
      "target_property": "visible",
      "expression": ["equals", ["read", "verwarmingsinstallatie"], "overig"]
    },
    "warmwatervoorziening_type_overig.visible": {
      "target_identifier": "warmwatervoorziening_type_overig",
      "target_property": "visible",
      "expression": ["equals", ["read", "warmwatervoorziening_type"], "overig"]
    },
    "extra_warmwatervoorziening_type_overig.visible": {
      "target_identifier": "extra_warmwatervoorziening_type_overig",
      "target_property": "visible",
      "expression": ["equals", ["read", "extra_warmwatervoorziening_type"], "overig"]
    },
    "vloerplaat_1e_verdieping.visible": {
      "target_identifier": "vloerplaat_1e_verdieping",
      "target_property": "visible",
      "expression": ["greater", ["read", "totaal_aantal_verdiepingen"], 2]
    },
    "vloerplaat_2e_verdieping.visible": {
      "target_identifier": "vloerplaat_2e_verdieping",
      "target_property": "visible",
      "expression": ["greater", ["read", "totaal_aantal_verdiepingen"], 3]
    },
    "vloerplaat_3e_verdieping.visible": {
      "target_identifier": "vloerplaat_3e_verdieping",
      "target_property": "visible",
      "expression": ["greater", ["read", "totaal_aantal_verdiepingen"], 4]
    },
    "vloerplaat_4e_verdieping.visible": {
      "target_identifier": "vloerplaat_4e_verdieping",
      "target_property": "visible",
      "expression": ["greater", ["read", "totaal_aantal_verdiepingen"], 5]
    },
    "vloerplaat_5e_verdieping.visible": {
      "target_identifier": "vloerplaat_5e_verdieping",
      "target_property": "visible",
      "expression": ["greater", ["read", "totaal_aantal_verdiepingen"], 6]
    },
    "vloerplaat_zolder.visible": {
      "target_identifier": "vloerplaat_zolder",
      "target_property": "visible",
      "expression": ["greater", ["read", "totaal_aantal_verdiepingen"], 1]
    },
    "grondprijs_gemiddeld.value": {
      "target_identifier": "grondprijs_gemiddeld",
      "target_property": "value",
      "expression": ["divide", ["add", ["read", "grondprijs_min"], ["read", "grondprijs_max"]], 2]
    },
    "vloerplaatprijs_gemiddeld.value": {
      "target_identifier": "vloerplaatprijs_gemiddeld",
      "target_property": "value",
      "expression": ["divide", ["add", ["read", "vloerplaatprijs_min"], ["read", "vloerplaatprijs_max"]], 2]
    },
    "aantal_m2_aan_volle_waarde_meters.value": {
      "target_identifier": "aantal_m2_aan_volle_waarde_meters",
      "target_property": "value",
      "expression": ["multiply", ["read", "grondoppervlakte"], ["divide", 2, 3]]
    },
    "aantal_m2_aan_volle_waarde_bedrag.value": {
      "target_identifier": "aantal_m2_aan_volle_waarde_bedrag",
      "target_property": "value",
      "expression": ["multiply", ["read", "grondprijs_gemiddeld"], ["multiply", ["read", "aantal_m2_aan_volle_waarde_meters"], ["divide", ["read", "aantal_m2_aan_volle_waarde_factor"], 100]]]
    },
    "aantal_m2_verhouding_3_1_meters.value": {
      "target_identifier": "aantal_m2_verhouding_3_1_meters",
      "target_property": "value",
      "expression": ["multiply", ["read", "grondoppervlakte"], ["divide", 1, 3]]
    },
    "aantal_m2_verhouding_3_1_bedrag.value": {
      "target_identifier": "aantal_m2_verhouding_3_1_bedrag",
      "target_property": "value",
      "expression": ["multiply", ["read", "grondprijs_gemiddeld"], ["multiply", ["read", "aantal_m2_verhouding_3_1_meters"], ["divide", ["read", "aantal_m2_verhouding_3_1_factor"], 100]]]
    },
    "grondwaarde_perceel.value": {
      "target_identifier": "grondwaarde_perceel",
      "target_property": "value",
      "expression": ["add", ["read", "aantal_m2_aan_volle_waarde_bedrag"], ["read", "aantal_m2_verhouding_3_1_bedrag"]]
    },
    "reductie_percentage_bebouwd_perceel_bedrag.value": {
      "target_identifier": "reductie_percentage_bebouwd_perceel_bedrag",
      "target_property": "value",
      "expression": ["subtract", ["read", "grondwaarde_perceel"], ["multiply", ["read", "grondwaarde_perceel"], ["multiply", ["read", "reductie_percentage_bebouwd_perceel"], 0.01]]]
    },
    "grondprijs_perceel_na_correctie.value": {
      "target_identifier": "grondprijs_perceel_na_correctie",
      "target_property": "value",
      "expression": ["divide", ["read", "reductie_percentage_bebouwd_perceel_bedrag"], ["read", "grondoppervlakte"]]
    },
    "aanpalende_grond_totaal.value": {
      "target_identifier": "aanpalende_grond_totaal",
      "target_property": "value",
      "expression": ["multiply", ["read", "aanpalende_grond"], ["read", "oppervlakte_aanpalende_grond"]]
    },
    "waardeberekening_perceel_totaal.value": {
      "target_identifier": "waardeberekening_perceel_totaal",
      "target_property": "value",
      "expression": ["add", ["read", "reductie_percentage_bebouwd_perceel_bedrag"], ["read", "aanpalende_grond_totaal", 0]]
    },
    "totaal_bebouwbare_oppervlakte.value": {
      "target_identifier": "totaal_bebouwbare_oppervlakte",
      "target_property": "value",
      "expression": ["sum", ["map", "ruimtespecificatie", ["read", "oppervlakte"]]]
    },
    "totaal_bewoonbare_oppervlakte.value": {
      "target_identifier": "totaal_bewoonbare_oppervlakte",
      "target_property": "value",
      "expression": ["sum", ["map", "ruimtespecificatie", ["multiply", ["read", "oppervlakte"], ["multiply", ["read", "factor"], 0.01]]]]
    },
    "waarde_in_vloerplaatprijs.value": {
      "target_identifier": "waarde_in_vloerplaatprijs",
      "target_property": "value",
      "expression": ["multiply", ["read", "vloerplaatprijs_gemiddeld"], ["read", "totaal_bewoonbare_oppervlakte"]]
    },
    "vetusteit_ouderdom_jaren.value": {
      "target_identifier": "vetusteit_ouderdom_jaren",
      "target_property": "value",
      "expression": ["if", ["read", "renovatiejaar"], ["add", ["subtract", ["read", "renovatiejaar"], ["read", "bouwjaar"]], ["multiply", ["subtract", ["read", "referentiejaar"], ["read", "renovatiejaar"]], ["subtract", 1, ["divide", ["read", "renovatiepercentage"], 100]]]], ["subtract", ["read", "referentiejaar"], ["read", "bouwjaar"]]]
    },
    "vetusteit_ouderdom_percentage.value": {
      "target_identifier": "vetusteit_ouderdom_percentage",
      "target_property": "value",
      "expression": ["if", ["greater", ["round", ["multiply", ["read", "vetusteit_ouderdom_jaren"], 0.32], 1], 0.25], ["round", ["multiply", ["round", ["multiply", ["read", "vetusteit_ouderdom_jaren"], 0.32], 1], 1.3], 1], ["round", ["multiply", ["read", "vetusteit_ouderdom_jaren"], 0.32], 1]]
    },
    "waardeberekening_constructies_totaal.value": {
      "target_identifier": "waardeberekening_constructies_totaal",
      "target_property": "value",
      "expression": ["subtract", ["subtract", ["subtract", ["multiply", ["read", "vloerplaatprijs_gemiddeld"], ["read", "totaal_bewoonbare_oppervlakte"]], ["multiply", ["multiply", ["read", "vloerplaatprijs_gemiddeld"], ["read", "totaal_bewoonbare_oppervlakte"]], ["multiply", ["read", "vetusteit_ouderdom_percentage"], 0.01]]], ["multiply", ["multiply", ["read", "vloerplaatprijs_gemiddeld"], ["read", "totaal_bewoonbare_oppervlakte"]], ["multiply", ["read", "vetusteit_onderhoud"], 0.01]]], ["multiply", ["multiply", ["read", "vloerplaatprijs_gemiddeld"], ["read", "totaal_bewoonbare_oppervlakte"]], ["multiply", ["read", "vetusteit_gebruik"], 0.01]]]
    },
    "waardeberekening_grond_min.value": {
      "target_identifier": "waardeberekening_grond_min",
      "target_property": "value",
      "expression": ["subtract", ["add", ["multiply", ["read", "grondprijs_min"], ["multiply", ["read", "aantal_m2_aan_volle_waarde_meters"], ["divide", ["read", "aantal_m2_aan_volle_waarde_factor"], 100]]], ["multiply", ["read", "grondprijs_min"], ["multiply", ["read", "aantal_m2_verhouding_3_1_meters"], ["divide", ["read", "aantal_m2_verhouding_3_1_factor"], 100]]]], ["multiply", ["add", ["multiply", ["read", "grondprijs_min"], ["multiply", ["read", "aantal_m2_aan_volle_waarde_meters"], ["divide", ["read", "aantal_m2_aan_volle_waarde_factor"], 100]]], ["multiply", ["read", "grondprijs_min"], ["multiply", ["read", "aantal_m2_verhouding_3_1_meters"], ["divide", ["read", "aantal_m2_verhouding_3_1_factor"], 100]]]], ["multiply", ["read", "reductie_percentage_bebouwd_perceel"], 0.01]]]
    },
    "waardeberekening_grond_max.value": {
      "target_identifier": "waardeberekening_grond_max",
      "target_property": "value",
      "expression": ["subtract", ["add", ["multiply", ["read", "grondprijs_max"], ["multiply", ["read", "aantal_m2_aan_volle_waarde_meters"], ["divide", ["read", "aantal_m2_aan_volle_waarde_factor"], 100]]], ["multiply", ["read", "grondprijs_max"], ["multiply", ["read", "aantal_m2_verhouding_3_1_meters"], ["divide", ["read", "aantal_m2_verhouding_3_1_factor"], 100]]]], ["multiply", ["add", ["multiply", ["read", "grondprijs_max"], ["multiply", ["read", "aantal_m2_aan_volle_waarde_meters"], ["divide", ["read", "aantal_m2_aan_volle_waarde_factor"], 100]]], ["multiply", ["read", "grondprijs_max"], ["multiply", ["read", "aantal_m2_verhouding_3_1_meters"], ["divide", ["read", "aantal_m2_verhouding_3_1_factor"], 100]]]], ["multiply", ["read", "reductie_percentage_bebouwd_perceel"], 0.01]]]
    },
    "waardeberekening_aanpalende_grond_min.value": {
      "target_identifier": "waardeberekening_aanpalende_grond_min",
      "target_property": "value",
      "expression": ["multiply", ["read", "aanpalende_grond"], ["read", "oppervlakte_aanpalende_grond"]]
    },
    "waardeberekening_aanpalende_grond_max.value": {
      "target_identifier": "waardeberekening_aanpalende_grond_max",
      "target_property": "value",
      "expression": ["multiply", ["read", "aanpalende_grond"], ["read", "oppervlakte_aanpalende_grond"]]
    },
    "waardeberekening_constructie_min.value": {
      "target_identifier": "waardeberekening_constructie_min",
      "target_property": "value",
      "expression": ["multiply", ["read", "vloerplaatprijs_min"], ["read", "totaal_bewoonbare_oppervlakte"]]
    },
    "waardeberekening_constructie_max.value": {
      "target_identifier": "waardeberekening_constructie_max",
      "target_property": "value",
      "expression": ["multiply", ["read", "vloerplaatprijs_max"], ["read", "totaal_bewoonbare_oppervlakte"]]
    },
    "waardeberekening_subtotaal_1_min.value": {
      "target_identifier": "waardeberekening_subtotaal_1_min",
      "target_property": "value",
      "expression": ["add", ["read", "waardeberekening_grond_min", 0], ["add", ["read", "waardeberekening_aanpalende_grond_min", 0], ["read", "waardeberekening_constructie_min", 0]]]
    },
    "waardeberekening_subtotaal_1_max.value": {
      "target_identifier": "waardeberekening_subtotaal_1_max",
      "target_property": "value",
      "expression": ["add", ["read", "waardeberekening_grond_max", 0], ["add", ["read", "waardeberekening_aanpalende_grond_max", 0], ["read", "waardeberekening_constructie_max", 0]]]
    },
    "waardeberekening_vetusteit.value": {
      "target_identifier": "waardeberekening_vetusteit",
      "target_property": "value",
      "expression": ["add", ["read", "vetusteit_ouderdom_percentage", 0], ["add", ["read", "vetusteit_gebruik", 0], ["read", "vetusteit_onderhoud", 0]]]
    },
    "waardeberekening_vetusteit_min.value": {
      "target_identifier": "waardeberekening_vetusteit_min",
      "target_property": "value",
      "expression": ["multiply", ["negate", ["read", "waardeberekening_constructie_min", 0]], ["divide", ["read", "waardeberekening_vetusteit"], 100]]
    },
    "waardeberekening_vetusteit_max.value": {
      "target_identifier": "waardeberekening_vetusteit_max",
      "target_property": "value",
      "expression": ["multiply", ["negate", ["read", "waardeberekening_constructie_max", 0]], ["divide", ["read", "waardeberekening_vetusteit"], 100]]
    },
    "waardeberekening_subtotaal_2_min.value": {
      "target_identifier": "waardeberekening_subtotaal_2_min",
      "target_property": "value",
      "expression": ["add", ["read", "waardeberekening_subtotaal_1_min"], ["read", "waardeberekening_vetusteit_min"]]
    },
    "waardeberekening_subtotaal_2_max.value": {
      "target_identifier": "waardeberekening_subtotaal_2_max",
      "target_property": "value",
      "expression": ["add", ["read", "waardeberekening_subtotaal_1_max"], ["read", "waardeberekening_vetusteit_max"]]
    },
    "economische_meerwaarde_min.value": {
      "target_identifier": "economische_meerwaarde_min",
      "target_property": "value",
      "expression": ["multiply", ["add", ["read", "reductie_percentage_bebouwd_perceel_bedrag"], ["add", ["read", "waardeberekening_constructie_min"], ["read", "waardeberekening_vetusteit_min"]]], ["divide", ["read", "economische_meerwaarde_factor"], 100]]
    },
    "economische_meerwaarde_max.value": {
      "target_identifier": "economische_meerwaarde_max",
      "target_property": "value",
      "expression": ["multiply", ["add", ["read", "reductie_percentage_bebouwd_perceel_bedrag"], ["add", ["read", "waardeberekening_constructie_max"], ["read", "waardeberekening_vetusteit_max"]]], ["divide", ["read", "economische_meerwaarde_factor"], 100]]
    },
    "economische_minwaarde_min.value": {
      "target_identifier": "economische_minwaarde_min",
      "target_property": "value",
      "expression": ["negate", ["multiply", ["add", ["read", "reductie_percentage_bebouwd_perceel_bedrag"], ["add", ["read", "waardeberekening_constructie_min"], ["read", "waardeberekening_vetusteit_min"]]], ["divide", ["read", "economische_minwaarde_factor"], 100]]]
    },
    "economische_minwaarde_max.value": {
      "target_identifier": "economische_minwaarde_max",
      "target_property": "value",
      "expression": ["negate", ["multiply", ["add", ["read", "reductie_percentage_bebouwd_perceel_bedrag"], ["add", ["read", "waardeberekening_constructie_max"], ["read", "waardeberekening_vetusteit_max"]]], ["divide", ["read", "economische_minwaarde_factor"], 100]]]
    },
    "waardeberekening_subtotaal_3_min.value": {
      "target_identifier": "waardeberekening_subtotaal_3_min",
      "target_property": "value",
      "expression": ["add", ["read", "waardeberekening_subtotaal_2_min"], ["add", ["read", "economische_meerwaarde_min", 0], ["read", "economische_minwaarde_min", 0]]]
    },
    "waardeberekening_subtotaal_3_max.value": {
      "target_identifier": "waardeberekening_subtotaal_3_max",
      "target_property": "value",
      "expression": ["add", ["read", "waardeberekening_subtotaal_2_max"], ["add", ["read", "economische_meerwaarde_max", 0], ["read", "economische_minwaarde_max", 0]]]
    },
    "intrinsieke_waarde.value": {
      "target_identifier": "intrinsieke_waarde",
      "target_property": "value",
      "expression": ["divide", ["add", ["read", "waardeberekening_subtotaal_3_min"], ["read", "waardeberekening_subtotaal_3_max"]], 2]
    },
    "adviesprijs_makelaar_bedrag.visible": {
      "target_identifier": "adviesprijs_makelaar_bedrag",
      "target_property": "visible",
      "expression": ["equals", ["read", "adviesprijs_makelaar_type"], "prijs_tonen"]
    }
  },
  "rule_dependencies": {
    "adresgegevens_gelijk_aan_te_schatten_eigendom.value": ["te_schatten_eigendom.visible"],
    "onroerend_goed_type.value": ["onroerend_goed_subtype.group"],
    "kadastrale_gegevens_beschikbaar.value": ["kadastrale_gegevens.visible"],
    "staat_van_het_eigendom.value": ["staat_van_het_eigendom_andere.visible"],
    "bijgebouw_aanwezig.value": ["dakconstructie_bijgebouw.visible"],
    "aanbouw_aanwezig.value": ["dakconstructie_aanbouw.visible"],
    "vloerisolatie_aanwezig.value": ["vloerisolatie_type.visible"],
    "dakisolatie_aanwezig.value": ["dakisolatie_type.visible"],
    "zolderplaat_aanwezig.value": ["zolderplaat_type.visible"],
    "alarminstallatie_aanwezig.value": ["alarminstallatie_type.visible"],
    "kelderverdieping_aanwezig.value": ["kelderverdieping_type.visible"],
    "epc_aanwezig.value": ["epc_waarde.visible"],
    "zolderverdieping_aanwezig.value": ["zolderverdieping_trap.visible"],
    "tuin_aanwezig.value": ["tuin_details.visible"],
    "type_ruwbouw.value": ["type_ruwbouw_overig.visible"],
    "muurisolatie.value": ["muurisolatie_overig.visible"],
    "type_verwarming.value": ["type_verwarming_overig.visible"],
    "verwarmingsinstallatie.value": ["verwarmingsinstallatie_overig.visible"],
    "warmwatervoorziening_type.value": ["warmwatervoorziening_type_overig.visible"],
    "extra_warmwatervoorziening_type.value": ["extra_warmwatervoorziening_type_overig.visible"],
    "totaal_aantal_verdiepingen.value": ["vloerplaat_zolder.visible", "vloerplaat_5e_verdieping.visible", "vloerplaat_4e_verdieping.visible", "vloerplaat_3e_verdieping.visible", "vloerplaat_2e_verdieping.visible", "vloerplaat_1e_verdieping.visible"],
    "grondprijs_min.value": ["waardeberekening_grond_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "grondprijs_gemiddeld.value", "aantal_m2_verhouding_3_1_bedrag.value", "aantal_m2_aan_volle_waarde_bedrag.value", "grondwaarde_perceel.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "grondprijs_max.value": ["waardeberekening_grond_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "grondprijs_gemiddeld.value", "aantal_m2_verhouding_3_1_bedrag.value", "aantal_m2_aan_volle_waarde_bedrag.value", "grondwaarde_perceel.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "vloerplaatprijs_min.value": ["waardeberekening_constructie_min.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "vloerplaatprijs_gemiddeld.value", "waardeberekening_constructies_totaal.value", "waarde_in_vloerplaatprijs.value"],
    "vloerplaatprijs_max.value": ["waardeberekening_constructie_max.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "intrinsieke_waarde.value", "vloerplaatprijs_gemiddeld.value", "waardeberekening_constructies_totaal.value", "waarde_in_vloerplaatprijs.value"],
    "grondoppervlakte.value": ["aantal_m2_verhouding_3_1_meters.value", "aantal_m2_verhouding_3_1_bedrag.value", "aantal_m2_aan_volle_waarde_meters.value", "waardeberekening_grond_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_grond_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "aantal_m2_aan_volle_waarde_bedrag.value", "grondwaarde_perceel.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "grondprijs_gemiddeld.value": ["aantal_m2_verhouding_3_1_bedrag.value", "aantal_m2_aan_volle_waarde_bedrag.value", "grondwaarde_perceel.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "aantal_m2_aan_volle_waarde_meters.value": ["waardeberekening_grond_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_grond_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "aantal_m2_aan_volle_waarde_bedrag.value", "grondwaarde_perceel.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "aantal_m2_aan_volle_waarde_factor.value": ["waardeberekening_grond_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_grond_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "aantal_m2_aan_volle_waarde_bedrag.value", "grondwaarde_perceel.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "aantal_m2_verhouding_3_1_meters.value": ["waardeberekening_grond_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_grond_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "aantal_m2_verhouding_3_1_bedrag.value", "grondwaarde_perceel.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "aantal_m2_verhouding_3_1_factor.value": ["waardeberekening_grond_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_grond_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "aantal_m2_verhouding_3_1_bedrag.value", "grondwaarde_perceel.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "aantal_m2_aan_volle_waarde_bedrag.value": ["grondwaarde_perceel.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "aantal_m2_verhouding_3_1_bedrag.value": ["grondwaarde_perceel.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "grondwaarde_perceel.value": ["reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "reductie_percentage_bebouwd_perceel.value": ["waardeberekening_grond_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_grond_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "reductie_percentage_bebouwd_perceel_bedrag.value": ["economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value"],
    "aanpalende_grond.value": ["waardeberekening_aanpalende_grond_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_aanpalende_grond_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "aanpalende_grond_totaal.value", "waardeberekening_perceel_totaal.value"],
    "oppervlakte_aanpalende_grond.value": ["waardeberekening_aanpalende_grond_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_aanpalende_grond_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "aanpalende_grond_totaal.value", "waardeberekening_perceel_totaal.value"],
    "aanpalende_grond_totaal.value": ["waardeberekening_perceel_totaal.value"],
    "ruimtespecificatie.items": ["totaal_bewoonbare_oppervlakte.value", "waardeberekening_constructie_max.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_constructie_min.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value", "waarde_in_vloerplaatprijs.value", "totaal_bebouwbare_oppervlakte.value"],
    "ruimtespecificatie.items.oppervlakte.value": ["totaal_bewoonbare_oppervlakte.value", "waardeberekening_constructie_max.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_constructie_min.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value", "waarde_in_vloerplaatprijs.value", "totaal_bebouwbare_oppervlakte.value"],
    "ruimtespecificatie.items.factor.value": ["totaal_bewoonbare_oppervlakte.value", "waardeberekening_constructie_max.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_constructie_min.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value", "waarde_in_vloerplaatprijs.value"],
    "vloerplaatprijs_gemiddeld.value": ["waardeberekening_constructies_totaal.value", "waarde_in_vloerplaatprijs.value"],
    "totaal_bewoonbare_oppervlakte.value": ["waardeberekening_constructie_max.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_constructie_min.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value", "waarde_in_vloerplaatprijs.value"],
    "renovatiejaar.value": ["vetusteit_ouderdom_jaren.value", "vetusteit_ouderdom_percentage.value", "waardeberekening_vetusteit.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value"],
    "bouwjaar.value": ["vetusteit_ouderdom_jaren.value", "vetusteit_ouderdom_percentage.value", "waardeberekening_vetusteit.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value"],
    "referentiejaar.value": ["vetusteit_ouderdom_jaren.value", "vetusteit_ouderdom_percentage.value", "waardeberekening_vetusteit.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value"],
    "renovatiepercentage.value": ["vetusteit_ouderdom_jaren.value", "vetusteit_ouderdom_percentage.value", "waardeberekening_vetusteit.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value"],
    "vetusteit_ouderdom_jaren.value": ["vetusteit_ouderdom_percentage.value", "waardeberekening_vetusteit.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value"],
    "vetusteit_ouderdom_percentage.value": ["waardeberekening_vetusteit.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value"],
    "vetusteit_onderhoud.value": ["waardeberekening_vetusteit.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value"],
    "vetusteit_gebruik.value": ["waardeberekening_vetusteit.value", "waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_constructies_totaal.value"],
    "waardeberekening_grond_min.value": ["waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value"],
    "waardeberekening_aanpalende_grond_min.value": ["waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value"],
    "waardeberekening_constructie_min.value": ["waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value"],
    "waardeberekening_grond_max.value": ["waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "intrinsieke_waarde.value"],
    "waardeberekening_aanpalende_grond_max.value": ["waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "intrinsieke_waarde.value"],
    "waardeberekening_constructie_max.value": ["waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "intrinsieke_waarde.value"],
    "waardeberekening_vetusteit.value": ["waardeberekening_vetusteit_max.value", "economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "waardeberekening_vetusteit_min.value", "economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value"],
    "waardeberekening_subtotaal_1_min.value": ["waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value"],
    "waardeberekening_vetusteit_min.value": ["economische_minwaarde_min.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_2_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value"],
    "waardeberekening_subtotaal_1_max.value": ["waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "intrinsieke_waarde.value"],
    "waardeberekening_vetusteit_max.value": ["economische_minwaarde_max.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_subtotaal_3_max.value", "intrinsieke_waarde.value"],
    "economische_meerwaarde_factor.value": ["economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value"],
    "economische_minwaarde_factor.value": ["economische_minwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_minwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value"],
    "waardeberekening_subtotaal_2_min.value": ["waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value"],
    "economische_meerwaarde_min.value": ["waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value"],
    "economische_minwaarde_min.value": ["waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value"],
    "waardeberekening_subtotaal_2_max.value": ["waardeberekening_subtotaal_3_max.value", "intrinsieke_waarde.value"],
    "economische_meerwaarde_max.value": ["waardeberekening_subtotaal_3_max.value", "intrinsieke_waarde.value"],
    "economische_minwaarde_max.value": ["waardeberekening_subtotaal_3_max.value", "intrinsieke_waarde.value"],
    "waardeberekening_subtotaal_3_min.value": ["intrinsieke_waarde.value"],
    "waardeberekening_subtotaal_3_max.value": ["intrinsieke_waarde.value"],
    "adviesprijs_makelaar_type.value": ["adviesprijs_makelaar_bedrag.visible"],
    "_all": ["adviesprijs_makelaar_bedrag.visible", "vetusteit_ouderdom_jaren.value", "vetusteit_ouderdom_percentage.value", "waardeberekening_vetusteit.value", "totaal_bewoonbare_oppervlakte.value", "totaal_bebouwbare_oppervlakte.value", "waardeberekening_aanpalende_grond_max.value", "waardeberekening_aanpalende_grond_min.value", "aanpalende_grond_totaal.value", "aantal_m2_verhouding_3_1_meters.value", "aantal_m2_aan_volle_waarde_meters.value", "waardeberekening_constructie_max.value", "waardeberekening_vetusteit_max.value", "waardeberekening_constructie_min.value", "waardeberekening_vetusteit_min.value", "vloerplaatprijs_gemiddeld.value", "waardeberekening_constructies_totaal.value", "waarde_in_vloerplaatprijs.value", "waardeberekening_grond_max.value", "waardeberekening_subtotaal_1_max.value", "waardeberekening_subtotaal_2_max.value", "waardeberekening_grond_min.value", "waardeberekening_subtotaal_1_min.value", "waardeberekening_subtotaal_2_min.value", "grondprijs_gemiddeld.value", "aantal_m2_verhouding_3_1_bedrag.value", "aantal_m2_aan_volle_waarde_bedrag.value", "grondwaarde_perceel.value", "reductie_percentage_bebouwd_perceel_bedrag.value", "economische_minwaarde_max.value", "economische_minwaarde_min.value", "economische_meerwaarde_max.value", "waardeberekening_subtotaal_3_max.value", "economische_meerwaarde_min.value", "waardeberekening_subtotaal_3_min.value", "intrinsieke_waarde.value", "waardeberekening_perceel_totaal.value", "grondprijs_perceel_na_correctie.value", "vloerplaat_zolder.visible", "vloerplaat_5e_verdieping.visible", "vloerplaat_4e_verdieping.visible", "vloerplaat_3e_verdieping.visible", "vloerplaat_2e_verdieping.visible", "vloerplaat_1e_verdieping.visible", "extra_warmwatervoorziening_type_overig.visible", "warmwatervoorziening_type_overig.visible", "verwarmingsinstallatie_overig.visible", "type_verwarming_overig.visible", "muurisolatie_overig.visible", "type_ruwbouw_overig.visible", "tuin_details.visible", "zolderverdieping_trap.visible", "epc_waarde.visible", "kelderverdieping_type.visible", "alarminstallatie_type.visible", "zolderplaat_type.visible", "dakisolatie_type.visible", "vloerisolatie_type.visible", "dakconstructie_aanbouw.visible", "dakconstructie_bijgebouw.visible", "staat_van_het_eigendom_andere.visible", "kadastrale_gegevens.visible", "onroerend_goed_subtype.group", "te_schatten_eigendom.visible"]
  },
  "subforms": {
    "renovatie": {
      "fields": {
        "wat_is_gerenoveerd": {
          "title": "Wat is gerenoveerd",
          "options": [{
            "identifier": "dakconstructie",
            "title": "Dakconstructie"
          }, {
            "identifier": "elektriciteitsnet",
            "title": "Elektriciteitsnet"
          }, {
            "identifier": "sanitaire_leidingen",
            "title": "Sanitaire leidingen"
          }, {
            "identifier": "keuken",
            "title": "Keuken"
          }, {
            "identifier": "verwarming",
            "title": "Verwarming"
          }, {
            "identifier": "vloer",
            "title": "Vloer"
          }, {
            "identifier": "badkamer",
            "title": "Badkamer"
          }, {
            "identifier": "buitenschrijnwerk",
            "title": "Buitenschrijnwerk"
          }, {
            "identifier": "binnenschrijnwerk",
            "title": "Binnenschrijnwerk"
          }, {
            "identifier": "schilderwerken",
            "title": "Schilderwerken"
          }, {
            "identifier": "gevelreiniging",
            "title": "Gevelreiniging"
          }, {
            "identifier": "tuin",
            "title": "Tuin"
          }],
          "default": "dakconstructie",
          "type": "dropdown_field",
          "identifier": "wat_is_gerenoveerd"
        },
        "welke_onderdelen": {
          "title": "Welke onderdelen",
          "options": [{
            "identifier": "dakgoten_en_regenpijp_vernieuwd",
            "title": "Dakgoten en regenpijp vernieuwd",
            "group": "dakconstructie"
          }, {
            "identifier": "dakgoten_en_regenpijp_vernieuwd_zink",
            "title": "Dakgoten en regenpijp vernieuwd (Zink)",
            "group": "dakconstructie"
          }, {
            "identifier": "dakgoten_en_regenpijp_vernieuwd_koper",
            "title": "Dakgoten en regenpijp vernieuwd (Koper)",
            "group": "dakconstructie"
          }, {
            "identifier": "dakgoten_en_regenpijp_vernieuwd_pvc",
            "title": "Dakgoten en regenpijp vernieuwd (PVC)",
            "group": "dakconstructie"
          }, {
            "identifier": "dakleien_laten_reinigen_en_herspuiten",
            "title": "Dakleien laten reinigen en herspuiten",
            "group": "dakconstructie"
          }, {
            "identifier": "nieuw_dak_over_bestaand_gelegd",
            "title": "Nieuw dak over bestaand gelegd",
            "group": "dakconstructie"
          }, {
            "identifier": "volledig_vervangen",
            "title": "Volledig vervangen",
            "group": "dakconstructie"
          }, {
            "identifier": "gedeeltelijk_vervangen",
            "title": "Gedeeltelijk vervangen",
            "group": "dakconstructie"
          }, {
            "identifier": "volledig_vernieuwd",
            "title": "Volledig vernieuwd",
            "group": "elektriciteitsnet"
          }, {
            "identifier": "gedeeltelijk_vernieuwd",
            "title": "Gedeeltelijk vernieuwd",
            "group": "elektriciteitsnet"
          }, {
            "identifier": "bedrading_vernieuwd",
            "title": "Bedrading vernieuwd",
            "group": "elektriciteitsnet"
          }, {
            "identifier": "net_verzwaard",
            "title": "Net verzwaard",
            "group": "elektriciteitsnet"
          }, {
            "identifier": "nieuwe_domoticakast",
            "title": "Nieuwe domoticakast",
            "group": "elektriciteitsnet"
          }, {
            "identifier": "nieuwe_standaard_zekeringenkast",
            "title": "Nieuwe standaard zekeringenkast",
            "group": "elektriciteitsnet"
          }, {
            "identifier": "volledig_vernieuwd",
            "title": "Volledig vernieuwd",
            "group": "sanitaire_leidingen"
          }, {
            "identifier": "gedeeltelijk_vernieuwd",
            "title": "Gedeeltelijk vernieuwd",
            "group": "sanitaire_leidingen"
          }, {
            "identifier": "volledig_vernieuwd",
            "title": "Volledig vernieuwd",
            "group": "keuken"
          }, {
            "identifier": "gedeeltelijk_vernieuwd",
            "title": "Gedeeltelijk vernieuwd",
            "group": "keuken"
          }, {
            "identifier": "geschilderd",
            "title": "Geschilderd",
            "group": "keuken"
          }, {
            "identifier": "gezandstraald",
            "title": "Gezandstraald",
            "group": "keuken"
          }, {
            "identifier": "nieuw_natuurstenen_werkblad",
            "title": "Nieuw natuurstenen werkblad",
            "group": "keuken"
          }, {
            "identifier": "nieuw_houten_werkblad",
            "title": "Nieuw houten werkblad",
            "group": "keuken"
          }, {
            "identifier": "nieuw_multiplex_werkblad",
            "title": "Nieuw multiplex werkblad",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_heteluchtoven",
            "title": "Nieuwe heteluchtoven",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_combioven",
            "title": "Nieuwe combioven",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_amerikaanse_ijskast",
            "title": "Nieuwe Amerikaanse ijskast",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_ijskast",
            "title": "Nieuwe ijskast",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_diepvriezer",
            "title": "Nieuwe diepvriezer",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_magnetron",
            "title": "Nieuwe magnetron",
            "group": "keuken"
          }, {
            "identifier": "nieuw_gasfornuis",
            "title": "Nieuw gasfornuis",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_keramische_kookplaat",
            "title": "Nieuwe keramische kookplaat",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_inductiekookplaat",
            "title": "Nieuwe inductiekookplaat",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_dampkap",
            "title": "Nieuwe dampkap",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_ingebouwde_koffiemachine",
            "title": "Nieuwe ingebouwde koffiemachine",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_cooker",
            "title": "Nieuwe cooker",
            "group": "keuken"
          }, {
            "identifier": "nieuwe_vaatwasser",
            "title": "Nieuwe vaatwasser",
            "group": "keuken"
          }, {
            "identifier": "volledig_nieuw_verwarmingsnet",
            "title": "Volledig nieuw verwarmingsnet",
            "group": "verwarming"
          }, {
            "identifier": "gedeeltelijk_nieuw_verwarmingsnet",
            "title": "Gedeeltelijk nieuw verwarmingsnet",
            "group": "verwarming"
          }, {
            "identifier": "nieuwe_leidingen_verwarming",
            "title": "Nieuwe leidingen verwarminging",
            "group": "verwarming"
          }, {
            "identifier": "nieuwe_cv_ketel",
            "title": "Nieuwe cv-ketel",
            "group": "verwarming"
          }, {
            "identifier": "nieuwe_brander",
            "title": "Nieuwe brander",
            "group": "verwarming"
          }, {
            "identifier": "nieuwe_boiler",
            "title": "Nieuwe boiler",
            "group": "verwarming"
          }, {
            "identifier": "volledig_vernieuwd",
            "title": "Volledig vernieuwd",
            "group": "vloer"
          }, {
            "identifier": "woonkamer",
            "title": "Woonkamer",
            "group": "vloer"
          }, {
            "identifier": "keuken",
            "title": "Keuken",
            "group": "vloer"
          }, {
            "identifier": "bijkeuken",
            "title": "Bijkeuken",
            "group": "vloer"
          }, {
            "identifier": "inkomhal",
            "title": "Inkomhal",
            "group": "vloer"
          }, {
            "identifier": "toilet",
            "title": "Toilet",
            "group": "vloer"
          }, {
            "identifier": "veranda",
            "title": "Veranda",
            "group": "vloer"
          }, {
            "identifier": "bureel",
            "title": "Bureel",
            "group": "vloer"
          }, {
            "identifier": "slaapkamers",
            "title": "Slaapkamer(s)",
            "group": "vloer"
          }, {
            "identifier": "badkamer",
            "title": "Badkamer",
            "group": "vloer"
          }, {
            "identifier": "hobbyruimte",
            "title": "Hobbyruimte",
            "group": "vloer"
          }, {
            "identifier": "garage",
            "title": "Garage",
            "group": "vloer"
          }, {
            "identifier": "volledig_vernieuwd",
            "title": "Volledig vernieuwd",
            "group": "badkamer"
          }, {
            "identifier": "gedeeltelijk_vernieuwd",
            "title": "Gedeeltelijk vernieuwd",
            "group": "badkamer"
          }, {
            "identifier": "badkamermeubel_vernieuwd",
            "title": "Badkamermeubel vernieuwd",
            "group": "badkamer"
          }, {
            "identifier": "ligbad_vernieuwd",
            "title": "Ligbad vernieuwd",
            "group": "badkamer"
          }, {
            "identifier": "toilet_vernieuwd",
            "title": "Toilet vernieuwd",
            "group": "badkamer"
          }, {
            "identifier": "douche_vernieuwd",
            "title": "Douche vernieuwd",
            "group": "badkamer"
          }, {
            "identifier": "bidet_vernieuwd",
            "title": "Bidet vernieuwd",
            "group": "badkamer"
          }, {
            "identifier": "volledig_vervangen_in_pvc",
            "title": "Volledig vervangen in PVC",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "volledig_vervangen_in_aluminium",
            "title": "Volledig vervangen in aluminium",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "volledig_vervangen_in_hout",
            "title": "Volledig vervangen in hout",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "volledig_vervangen_in_hardhout_afzelia",
            "title": "Volledig vervangen in hardhout (afzelia)",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "volledig_vervangen_in_hardhout_meranti",
            "title": "Volledig vervangen in hardhout (meranti)",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "volledig_vervangen_in_hardhout_overige_soort",
            "title": "Volledig vervangen in hardhout (overige soort)",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "gedeeltelijk_vervangen",
            "title": "Gedeeltelijk vervangen",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "woonkamer",
            "title": "Woonkamer",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "keuken",
            "title": "Keuken",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "bijkeuken",
            "title": "Bijkeuken",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "inkomhal",
            "title": "Inkomhal",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "toilet",
            "title": "Toilet",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "veranda",
            "title": "Veranda",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "bureel",
            "title": "Bureel",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "slaapkamers",
            "title": "Slaapkamer(s)",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "badkamer",
            "title": "Badkamer",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "hobbyruimte",
            "title": "Hobbyruimte",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "garage",
            "title": "Garage",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "onderhoudswerken",
            "title": "Onderhoudswerken",
            "group": "buitenschrijnwerk"
          }, {
            "identifier": "volledig_vervangen",
            "title": "Volledig vervangen",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "gedeeltelijk_vervangen",
            "title": "Gedeeltelijk vervangen",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "woonkamer",
            "title": "Woonkamer",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "keuken",
            "title": "Keuken",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "bijkeuken",
            "title": "Bijkeuken",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "inkomhal",
            "title": "Inkomhal",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "toilet",
            "title": "Toilet",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "veranda",
            "title": "Veranda",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "bureel",
            "title": "Bureel",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "slaapkamers",
            "title": "Slaapkamer(s)",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "badkamer",
            "title": "Badkamer",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "hobbyruimte",
            "title": "Hobbyruimte",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "garage",
            "title": "Garage",
            "group": "binnenschrijnwerk"
          }, {
            "identifier": "gelijkvloers_volledig",
            "title": "Gelijkvloers volledig",
            "group": "schilderwerken"
          }, {
            "identifier": "gelijkvloers_gedeeltelijk",
            "title": "Gelijkvloers gedeeltelijk",
            "group": "schilderwerken"
          }, {
            "identifier": "bovenverdieping_volledig",
            "title": "Bovenverdieping volledig",
            "group": "schilderwerken"
          }, {
            "identifier": "bovenverdieping_gedeeltelijk",
            "title": "Bovenverdieping gedeeltelijk",
            "group": "schilderwerken"
          }, {
            "identifier": "woonkamer",
            "title": "Woonkamer",
            "group": "schilderwerken"
          }, {
            "identifier": "keuken",
            "title": "Keuken",
            "group": "schilderwerken"
          }, {
            "identifier": "bijkeuken",
            "title": "Bijkeuken",
            "group": "schilderwerken"
          }, {
            "identifier": "inkomhal",
            "title": "Inkomhal",
            "group": "schilderwerken"
          }, {
            "identifier": "toilet",
            "title": "Toilet",
            "group": "schilderwerken"
          }, {
            "identifier": "veranda",
            "title": "Veranda",
            "group": "schilderwerken"
          }, {
            "identifier": "bureel",
            "title": "Bureel",
            "group": "schilderwerken"
          }, {
            "identifier": "slaapkamers",
            "title": "Slaapkamer(s)",
            "group": "schilderwerken"
          }, {
            "identifier": "badkamer",
            "title": "Badkamer",
            "group": "schilderwerken"
          }, {
            "identifier": "hobbyruimte",
            "title": "Hobbyruimte",
            "group": "schilderwerken"
          }, {
            "identifier": "garage",
            "title": "Garage",
            "group": "schilderwerken"
          }, {
            "identifier": "buitengevel",
            "title": "Buitengevel",
            "group": "schilderwerken"
          }, {
            "identifier": "volledig_gereinigd",
            "title": "Volledig gereinigd",
            "group": "gevelreiniging"
          }, {
            "identifier": "gedeeltelijk_gereinigd",
            "title": "Gedeeltelijk gereinigd",
            "group": "gevelreiniging"
          }, {
            "identifier": "opnieuw_ingevoegd",
            "title": "Opnieuw ingevoegd",
            "group": "gevelreiniging"
          }, {
            "identifier": "tuinaanleg_eigen_ontwerp",
            "title": "Tuinaanleg eigen ontwerp",
            "group": "tuin"
          }, {
            "identifier": "tuinaanleg_tuinarchitect",
            "title": "Tuinaanleg tuinarchitect",
            "group": "tuin"
          }],
          "type": "dropdown_field",
          "identifier": "welke_onderdelen"
        },
        "jaartal": {
          "title": "Jaartal",
          "precision": 0,
          "maximum": 2050,
          "type": "numeric_field",
          "identifier": "jaartal"
        }
      },
      "rules": {
        "welke_onderdelen.group": {
          "target_identifier": "welke_onderdelen",
          "target_property": "group",
          "expression": ["read", "wat_is_gerenoveerd"]
        }
      },
      "rule_dependencies": {
        "wat_is_gerenoveerd.value": ["welke_onderdelen.group"],
        "_all": ["welke_onderdelen.group"]
      },
      "view": {
        "type": "panel",
        "children": [{
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "wat_is_gerenoveerd",
            "type": "field",
            "children": []
          }, {
            "identifier": "welke_onderdelen",
            "type": "field",
            "children": []
          }, {
            "identifier": "jaartal",
            "type": "field",
            "children": []
          }]
        }]
      }
    },
    "waardebeinvloedende_factor": {
      "fields": {
        "factor": {
          "type": "text_field",
          "identifier": "factor"
        }
      },
      "view": {
        "type": "panel",
        "children": [{
          "identifier": "factor",
          "type": "field",
          "children": []
        }]
      }
    },
    "ruimte": {
      "fields": {
        "ruimte": {
          "options": [{
            "identifier": "gelijkvloers",
            "title": "Gelijkvloers"
          }, {
            "identifier": "eerste_verdieping",
            "title": "Eerste verdieping"
          }, {
            "identifier": "tweede_verdieping",
            "title": "Tweede verdieping"
          }, {
            "identifier": "derde_verdieping",
            "title": "Derde verdieping"
          }, {
            "identifier": "vierde_verdieping",
            "title": "Vierde verdieping"
          }, {
            "identifier": "zolder",
            "title": "Zolder"
          }, {
            "identifier": "garage",
            "title": "Garage"
          }],
          "type": "dropdown_field",
          "identifier": "ruimte"
        },
        "oppervlakte": {
          "placeholder": "Voer een oppervlakte in",
          "precision": 2,
          "unit": "m²",
          "minimum": 0,
          "type": "numeric_field",
          "identifier": "oppervlakte"
        },
        "factor": {
          "placeholder": "Voer een factor in",
          "default": 100,
          "precision": 2,
          "unit": "%",
          "minimum": 0,
          "maximum": 100,
          "type": "numeric_field",
          "identifier": "factor"
        }
      },
      "view": {
        "type": "panel",
        "children": [{
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "ruimte",
            "type": "field",
            "children": []
          }, {
            "identifier": "oppervlakte",
            "type": "field",
            "children": []
          }, {
            "identifier": "factor",
            "type": "field",
            "children": []
          }]
        }]
      }
    }
  },
  "pages": [{
    "title": "Opdrachtgever",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Opdrachtgever",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "opdrachtgever_aanspreking",
            "type": "field",
            "children": []
          }, {
            "identifier": "opdrachtgever_achternaam",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "opdrachtgever_voornaam",
            "type": "field",
            "children": []
          }, {
            "identifier": "opdrachtgever_telefoon",
            "type": "field",
            "children": []
          }]
        }, {
          "identifier": "opdrachtgever_email",
          "type": "field",
          "children": []
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "opdrachtgever_straatnaam",
            "flex": 3,
            "type": "field",
            "children": []
          }, {
            "identifier": "opdrachtgever_huisnummer",
            "flex": 1,
            "type": "field",
            "children": []
          }, {
            "identifier": "opdrachtgever_bus",
            "flex": 1,
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "opdrachtgever_postcode",
            "type": "field",
            "children": []
          }, {
            "identifier": "opdrachtgever_gemeente",
            "type": "field",
            "children": []
          }]
        }, {
          "identifier": "adresgegevens_gelijk_aan_te_schatten_eigendom",
          "type": "field",
          "children": []
        }, {
          "identifier": "te_schatten_eigendom",
          "flex_direction": "column",
          "spacing": 20,
          "type": "box",
          "children": [{
            "flex_direction": "row",
            "spacing": 20,
            "type": "box",
            "children": [{
              "identifier": "te_schatten_straatnaam",
              "flex": 3,
              "type": "field",
              "children": []
            }, {
              "identifier": "te_schatten_huisnummer",
              "flex": 1,
              "type": "field",
              "children": []
            }, {
              "identifier": "te_schatten_bus",
              "flex": 1,
              "type": "field",
              "children": []
            }]
          }, {
            "flex_direction": "row",
            "spacing": 20,
            "type": "box",
            "children": [{
              "identifier": "te_schatten_postcode",
              "type": "field",
              "children": []
            }, {
              "identifier": "te_schatten_gemeente",
              "type": "field",
              "children": []
            }]
          }]
        }]
      }]
    }, {
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Ligging en omgeving",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "ligging_en_omgeving",
          "type": "field",
          "children": []
        }]
      }]
    }]
  }, {
    "title": "Verplichte vastgoedinformatie",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Verplichte vastgoedinformatie",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 60,
          "type": "box",
          "children": [{
            "flex": 1,
            "flex_direction": "column",
            "spacing": 20,
            "type": "box",
            "children": [{
              "identifier": "stedenbouwkundige_vergunning_afgeleverd",
              "type": "field",
              "children": []
            }, {
              "identifier": "dagvaarding_uitgebracht",
              "type": "field",
              "children": []
            }, {
              "identifier": "voorkooprecht",
              "type": "field",
              "children": []
            }, {
              "identifier": "verkavelingsvergunning",
              "type": "field",
              "children": []
            }, {
              "identifier": "watertoets",
              "type": "field",
              "children": []
            }, {
              "identifier": "bestemmingsgebied",
              "type": "field",
              "children": []
            }]
          }, {
            "flex": 1,
            "flex_direction": "column",
            "spacing": 20,
            "type": "box",
            "children": [{
              "identifier": "as_built_attest_verkregen",
              "type": "field",
              "children": []
            }, {
              "identifier": "maakt_deel_uit_van_een_voorkeursbesluit_projectbesluit",
              "type": "field",
              "children": []
            }, {
              "identifier": "beschermd_eigendom",
              "type": "field",
              "children": []
            }]
          }]
        }]
      }]
    }]
  }, {
    "title": "Algemene informatie over het eigendom",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Algemene informatie over het eigendom",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 60,
          "type": "box",
          "children": [{
            "flex": 1,
            "flex_direction": "column",
            "spacing": 20,
            "type": "box",
            "children": [{
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "onroerend_goed_type",
                "type": "field",
                "children": []
              }, {
                "identifier": "onroerend_goed_subtype",
                "type": "field",
                "children": []
              }]
            }, {
              "identifier": "nieuwbouw",
              "type": "field",
              "children": []
            }, {
              "identifier": "bebouwing",
              "type": "field",
              "children": []
            }, {
              "identifier": "kadastrale_gegevens_beschikbaar",
              "type": "field",
              "children": []
            }, {
              "identifier": "kadastrale_gegevens",
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "kadastrale_afdeling",
                "type": "field",
                "children": []
              }, {
                "identifier": "kadastrale_sectie",
                "type": "field",
                "children": []
              }, {
                "identifier": "kadastraal_nummer",
                "type": "field",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "kadastraal_inkomen",
                "type": "field",
                "children": []
              }, {
                "identifier": "geindexeerd_ki",
                "type": "field",
                "children": []
              }]
            }, {
              "identifier": "onroerende_voorheffing",
              "type": "field",
              "children": []
            }]
          }, {
            "flex": 1,
            "flex_direction": "column",
            "spacing": 20,
            "type": "box",
            "children": [{
              "identifier": "aantal_slaapkamers",
              "type": "field",
              "children": []
            }, {
              "identifier": "aantal_badkamers",
              "type": "field",
              "children": []
            }, {
              "identifier": "aantal_keukens",
              "type": "field",
              "children": []
            }, {
              "identifier": "totaal_aantal_verdiepingen",
              "type": "field",
              "children": []
            }, {
              "identifier": "aannemer_ontwikkelaar",
              "type": "field",
              "children": []
            }, {
              "identifier": "aannemer_ontwikkelaar_andere",
              "type": "field",
              "children": []
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "staat_van_het_eigendom",
                "type": "field",
                "children": []
              }, {
                "identifier": "staat_van_het_eigendom_andere",
                "type": "field",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "bouwjaar",
                "type": "field",
                "children": []
              }, {
                "identifier": "renovaties_aanwezig",
                "type": "field",
                "children": []
              }]
            }]
          }]
        }]
      }]
    }]
  }, {
    "title": "Renovaties / vernieuwingen",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Renovaties / vernieuwingen",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "renovatiejaar",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }, {
          "identifier": "renovaties",
          "type": "field",
          "children": []
        }]
      }]
    }]
  }, {
    "title": "Constructie 1",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Ruwbouw",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "type_ruwbouw",
          "type": "field",
          "children": []
        }, {
          "identifier": "type_ruwbouw_overig",
          "type": "field",
          "children": []
        }]
      }, {
        "title": "Vloerplaat",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vloerplaat_gelijkvloers_aanwezig",
            "type": "field",
            "children": []
          }, {
            "identifier": "vloerplaat_gelijkvloers_type",
            "type": "field",
            "children": []
          }]
        }, {
          "identifier": "vloerplaat_1e_verdieping",
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vloerplaat_1e_verdieping_aanwezig",
            "type": "field",
            "children": []
          }, {
            "identifier": "vloerplaat_1e_verdieping_type",
            "type": "field",
            "children": []
          }]
        }, {
          "identifier": "vloerplaat_2e_verdieping",
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vloerplaat_2e_verdieping_aanwezig",
            "type": "field",
            "children": []
          }, {
            "identifier": "vloerplaat_2e_verdieping_type",
            "type": "field",
            "children": []
          }]
        }, {
          "identifier": "vloerplaat_3e_verdieping",
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vloerplaat_3e_verdieping_aanwezig",
            "type": "field",
            "children": []
          }, {
            "identifier": "vloerplaat_3e_verdieping_type",
            "type": "field",
            "children": []
          }]
        }, {
          "identifier": "vloerplaat_4e_verdieping",
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vloerplaat_4e_verdieping_aanwezig",
            "type": "field",
            "children": []
          }, {
            "identifier": "vloerplaat_4e_verdieping_type",
            "type": "field",
            "children": []
          }]
        }, {
          "identifier": "vloerplaat_5e_verdieping",
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vloerplaat_5e_verdieping_aanwezig",
            "type": "field",
            "children": []
          }, {
            "identifier": "vloerplaat_5e_verdieping_type",
            "type": "field",
            "children": []
          }]
        }, {
          "identifier": "vloerplaat_zolder",
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vloerplaat_zolder_aanwezig",
            "type": "field",
            "children": []
          }, {
            "identifier": "vloerplaat_zolder_type",
            "type": "field",
            "children": []
          }]
        }]
      }]
    }, {
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Dakconstructie",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "dakconstructie_hoofdgebouw_type",
            "type": "field",
            "children": []
          }, {
            "identifier": "dakconstructie_hoofdgebouw_grondstof",
            "type": "field",
            "children": []
          }]
        }, {
          "identifier": "bijgebouw_aanwezig",
          "type": "field",
          "children": []
        }, {
          "identifier": "dakconstructie_bijgebouw",
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "dakconstructie_bijgebouw_type",
            "type": "field",
            "children": []
          }, {
            "identifier": "dakconstructie_bijgebouw_grondstof",
            "type": "field",
            "children": []
          }]
        }, {
          "identifier": "aanbouw_aanwezig",
          "type": "field",
          "children": []
        }, {
          "identifier": "dakconstructie_aanbouw",
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "dakconstructie_aanbouw_type",
            "type": "field",
            "children": []
          }, {
            "identifier": "dakconstructie_aanbouw_grondstof",
            "type": "field",
            "children": []
          }]
        }]
      }]
    }]
  }, {
    "title": "Constructie 2",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Isolatie",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "epc_aanwezig",
            "type": "field",
            "children": []
          }, {
            "identifier": "epc_waarde",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "muurisolatie",
            "type": "field",
            "children": []
          }, {
            "identifier": "muurisolatie_overig",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vloerisolatie_aanwezig",
            "type": "field",
            "children": []
          }, {
            "identifier": "vloerisolatie_type",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "dakisolatie_aanwezig",
            "type": "field",
            "children": []
          }, {
            "identifier": "dakisolatie_type",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "zolderplaat_aanwezig",
            "type": "field",
            "children": []
          }, {
            "identifier": "zolderplaat_type",
            "type": "field",
            "children": []
          }]
        }]
      }]
    }, {
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Buitenschrijnwerk",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "buitenschrijnwerk_type",
          "type": "field",
          "children": []
        }, {
          "identifier": "buitenschrijnwerk_beglazing",
          "type": "field",
          "children": []
        }, {
          "identifier": "buitenschrijnwerk_luiken",
          "type": "field",
          "children": []
        }]
      }]
    }]
  }, {
    "title": "Verwarming en water",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Verwarming en warm water voorzieningen",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 60,
          "type": "box",
          "children": [{
            "flex": 1,
            "flex_direction": "column",
            "spacing": 20,
            "type": "box",
            "children": [{
              "identifier": "type_verwarming",
              "type": "field",
              "children": []
            }, {
              "identifier": "type_verwarming_overig",
              "type": "field",
              "children": []
            }, {
              "identifier": "verwarmingsinstallatie",
              "type": "field",
              "children": []
            }, {
              "identifier": "verwarmingsinstallatie_overig",
              "type": "field",
              "children": []
            }, {
              "identifier": "grondstof_verwarming",
              "type": "field",
              "children": []
            }, {
              "identifier": "bron_van_verwarming",
              "type": "field",
              "children": []
            }]
          }, {
            "flex": 1,
            "flex_direction": "column",
            "spacing": 20,
            "type": "box",
            "children": [{
              "identifier": "warmwatervoorziening_type",
              "type": "field",
              "children": []
            }, {
              "identifier": "warmwatervoorziening_type_overig",
              "type": "field",
              "children": []
            }, {
              "identifier": "extra_warmwatervoorziening_type",
              "type": "field",
              "children": []
            }, {
              "identifier": "extra_warmwatervoorziening_type_overig",
              "type": "field",
              "children": []
            }, {
              "identifier": "zonnepanelen_locatie",
              "type": "field",
              "children": []
            }, {
              "identifier": "vloerverwarming_locatie",
              "type": "field",
              "children": []
            }]
          }]
        }]
      }]
    }]
  }, {
    "title": "Installaties en parkeren",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Technische en elektrische installaties",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "elektrische_installatie_conform",
          "type": "field",
          "children": []
        }, {
          "identifier": "alarminstallatie_aanwezig",
          "type": "field",
          "children": []
        }, {
          "identifier": "alarminstallatie_type",
          "type": "field",
          "children": []
        }, {
          "identifier": "zonnescherm_screens",
          "type": "field",
          "children": []
        }, {
          "identifier": "type_installaties",
          "type": "field",
          "children": []
        }, {
          "identifier": "installatie_extras",
          "type": "field",
          "children": []
        }]
      }]
    }, {
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Garages en parkeerplaatsen",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "aantal_inpandige_garages",
          "type": "field",
          "children": []
        }, {
          "identifier": "aantal_uitpandige_garages",
          "type": "field",
          "children": []
        }, {
          "identifier": "garages_eigenschappen",
          "type": "field",
          "children": []
        }, {
          "identifier": "garages_aansluitingen",
          "type": "field",
          "children": []
        }, {
          "identifier": "aantal_staanplaatsen",
          "type": "field",
          "children": []
        }, {
          "identifier": "aantal_parkeerplaatsen",
          "type": "field",
          "children": []
        }]
      }]
    }]
  }, {
    "title": "Extra ruimtes",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Kelderverdieping",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "kelderverdieping_aanwezig",
          "type": "field",
          "children": []
        }, {
          "identifier": "kelderverdieping_type",
          "type": "field",
          "children": []
        }]
      }, {
        "title": "Zolderverdieping",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "zolderverdieping_aanwezig",
          "type": "field",
          "children": []
        }, {
          "identifier": "zolderverdieping_trap",
          "type": "field",
          "children": []
        }]
      }]
    }, {
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Tuin",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "tuin_aanwezig",
          "type": "field",
          "children": []
        }, {
          "identifier": "tuin_details",
          "flex_direction": "column",
          "spacing": 20,
          "type": "box",
          "children": [{
            "flex_direction": "row",
            "spacing": 20,
            "type": "box",
            "children": [{
              "identifier": "tuin_orientatie",
              "type": "field",
              "children": []
            }, {
              "identifier": "tuin_zwembad",
              "type": "field",
              "children": []
            }]
          }, {
            "identifier": "tuin_extras",
            "type": "field",
            "children": []
          }]
        }]
      }, {
        "title": "Nutsvoorzieningen",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "nutsvoorzieningen",
          "type": "field",
          "children": []
        }]
      }]
    }]
  }, {
    "title": "Waardebeïnvloedende factoren",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Waardebeïnvloedende factoren",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 60,
          "type": "box",
          "children": [{
            "flex": 1,
            "flex_direction": "column",
            "spacing": 20,
            "type": "box",
            "children": [{
              "identifier": "gunstige_factoren",
              "type": "field",
              "children": []
            }]
          }, {
            "flex": 1,
            "flex_direction": "column",
            "spacing": 20,
            "type": "box",
            "children": [{
              "identifier": "ongunstige_factoren",
              "type": "field",
              "children": []
            }]
          }]
        }]
      }]
    }]
  }, {
    "title": "Prijsberekening - perceel",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Oppervlakte perceel",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "straatbreedte",
          "type": "field",
          "children": []
        }, {
          "identifier": "diepte_breedte_verhouding",
          "type": "field",
          "children": []
        }, {
          "identifier": "grondoppervlakte",
          "type": "field",
          "children": []
        }, {
          "identifier": "oppervlakte_aanpalende_grond",
          "type": "field",
          "children": []
        }]
      }]
    }, {
      "flex": 3,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Waardeberekening perceel",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "grondprijs_min",
            "type": "field",
            "children": []
          }, {
            "identifier": "grondprijs_max",
            "type": "field",
            "children": []
          }, {
            "identifier": "grondprijs_gemiddeld",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "aantal_m2_aan_volle_waarde_meters",
            "type": "field",
            "children": []
          }, {
            "identifier": "aantal_m2_aan_volle_waarde_factor",
            "type": "field",
            "children": []
          }, {
            "identifier": "aantal_m2_aan_volle_waarde_bedrag",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "aantal_m2_verhouding_3_1_meters",
            "type": "field",
            "children": []
          }, {
            "identifier": "aantal_m2_verhouding_3_1_factor",
            "type": "field",
            "children": []
          }, {
            "identifier": "aantal_m2_verhouding_3_1_bedrag",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "type": "empty_space",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "identifier": "grondwaarde_perceel",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "reductie_percentage_bebouwd_perceel",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "identifier": "reductie_percentage_bebouwd_perceel_bedrag",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "type": "empty_space",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "identifier": "grondprijs_perceel_na_correctie",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "aanpalende_grond",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "identifier": "aanpalende_grond_totaal",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "type": "empty_space",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "identifier": "waardeberekening_perceel_totaal",
            "type": "field",
            "children": []
          }]
        }]
      }]
    }]
  }, {
    "title": "Prijsberekening - oppervlakte constructies",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Oppervlakte constructies",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vloerplaatprijs_min",
            "type": "field",
            "children": []
          }, {
            "identifier": "vloerplaatprijs_max",
            "type": "field",
            "children": []
          }, {
            "identifier": "vloerplaatprijs_gemiddeld",
            "type": "field",
            "children": []
          }]
        }, {
          "identifier": "ruimtespecificatie",
          "type": "field",
          "children": []
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "totaal_bebouwbare_oppervlakte",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "totaal_bewoonbare_oppervlakte",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "waarde_in_vloerplaatprijs",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }]
      }]
    }]
  }, {
    "title": "Prijsberekening - waardeberekening constructies",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Waardeberekening constructies",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "bouwjaar",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "renovatiejaar",
            "type": "field",
            "children": []
          }, {
            "identifier": "renovatiepercentage",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vetusteit_ouderdom_jaren",
            "type": "field",
            "children": []
          }, {
            "identifier": "vetusteit_ouderdom_percentage",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vetusteit_gebruik",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "vetusteit_onderhoud",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "waardeberekening_constructies_totaal",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }]
      }]
    }]
  }, {
    "title": "Prijsberekening - waardeberekening",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Waardeberekening",
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "flex_direction": "row",
          "spacing": 60,
          "type": "box",
          "children": [{
            "flex": 1,
            "flex_direction": "column",
            "spacing": 20,
            "type": "box",
            "children": [{
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "waardeberekening_grond_min",
                "type": "field",
                "children": []
              }, {
                "identifier": "waardeberekening_grond_max",
                "type": "field",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "waardeberekening_aanpalende_grond_min",
                "type": "field",
                "children": []
              }, {
                "identifier": "waardeberekening_aanpalende_grond_max",
                "type": "field",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "waardeberekening_constructie_min",
                "type": "field",
                "children": []
              }, {
                "identifier": "waardeberekening_constructie_max",
                "type": "field",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "waardeberekening_subtotaal_1_min",
                "type": "field",
                "children": []
              }, {
                "identifier": "waardeberekening_subtotaal_1_max",
                "type": "field",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "waardeberekening_vetusteit",
                "type": "field",
                "children": []
              }, {
                "type": "empty_space",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "waardeberekening_vetusteit_min",
                "type": "field",
                "children": []
              }, {
                "identifier": "waardeberekening_vetusteit_max",
                "type": "field",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "waardeberekening_subtotaal_2_min",
                "type": "field",
                "children": []
              }, {
                "identifier": "waardeberekening_subtotaal_2_max",
                "type": "field",
                "children": []
              }]
            }]
          }, {
            "flex": 1,
            "flex_direction": "column",
            "spacing": 20,
            "type": "box",
            "children": [{
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "economische_meerwaarde_factor",
                "type": "field",
                "children": []
              }, {
                "type": "empty_space",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "economische_meerwaarde_min",
                "type": "field",
                "children": []
              }, {
                "identifier": "economische_meerwaarde_max",
                "type": "field",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "economische_minwaarde_factor",
                "type": "field",
                "children": []
              }, {
                "type": "empty_space",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "economische_minwaarde_min",
                "type": "field",
                "children": []
              }, {
                "identifier": "economische_minwaarde_max",
                "type": "field",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "waardeberekening_subtotaal_3_min",
                "type": "field",
                "children": []
              }, {
                "identifier": "waardeberekening_subtotaal_3_max",
                "type": "field",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "intrinsieke_waarde",
                "type": "field",
                "children": []
              }, {
                "type": "empty_space",
                "children": []
              }]
            }, {
              "flex_direction": "row",
              "spacing": 20,
              "type": "box",
              "children": [{
                "identifier": "adviesprijs_makelaar_type",
                "type": "field",
                "children": []
              }, {
                "identifier": "adviesprijs_makelaar_bedrag",
                "type": "field",
                "children": []
              }]
            }]
          }]
        }]
      }]
    }]
  }, {
    "title": "Foto's en eindconclusie",
    "type": "page",
    "children": [{
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "VOEG 7 FOTO'S TOE",
        "flex": 1,
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "fotos",
          "flex": 1,
          "type": "field",
          "children": []
        }]
      }]
    }, {
      "flex": 1,
      "flex_direction": "column",
      "spacing": 20,
      "type": "panel",
      "children": [{
        "title": "Eindconclusie",
        "flex": 1,
        "flex_direction": "column",
        "type": "section",
        "children": [{
          "identifier": "eindconclusie_opgemaakt_voor",
          "type": "field",
          "children": []
        }, {
          "identifier": "eindconclusie_gelegen_aan",
          "type": "field",
          "children": []
        }, {
          "flex": 1,
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "eindconclusie_rekening_gehouden_met",
            "type": "field",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "eindconclusie_marktwaarde",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }, {
          "flex_direction": "row",
          "spacing": 20,
          "type": "box",
          "children": [{
            "identifier": "eindconclusie_maximale_vraagprijs",
            "type": "field",
            "children": []
          }, {
            "type": "empty_space",
            "children": []
          }]
        }]
      }]
    }]
  }]
};